/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createAccount = /* GraphQL */ `
  mutation CreateAccount(
    $input: CreateAccountInput!
    $condition: ModelAccountConditionInput
  ) {
    createAccount(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      businessName
      displayName
      accountNumber
      externalId
      externalStatus
      accountType
      defaultBillToAccountId
      lotNumberPrefix
      color
      defaultWeightUOM
      paymentTermId
      paymentTerm {
        id
        owner
        groups
        reloadYardId
        name
        code
        type
        dueDays
        dayOfMonthDue
        sortKey
        createdAt
        updatedAt
      }
      creditLimit
      overLimit
      overDue
      einNumber
      skipInvoice
      email
      phone
      fax
      website
      address {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      billingAddress {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      contacts {
        name
        email
        phone
        description
      }
      billingContacts {
        name
        email
        phone
        description
      }
      billingEmail
      invoiceSubject
      invoiceAttachments
      invoiceCustomFields {
        id
        name
        type
        display
        required
      }
      addressState
      reloadYardId
      inboundCustomFields {
        id
        name
        type
        display
        required
      }
      inboundInstructions
      secondaryReview
      inboundSkipSignature
      inboundPhotos
      podEmail
      podPhotos
      podAttachments
      podSubject
      inboundAdviceInputs
      inboundEventTypeId
      lotType
      lotNumberOverride
      fifoLotNumber
      carlotLotNumber
      verifyInboundRailCar
      trackInboundSeals
      requireDefaultZone
      outboundCustomFields {
        id
        name
        type
        display
        required
      }
      outboundInstructions
      posEmail
      posPhotos
      posAttachments
      posSubject
      outboundSkipSignature
      outboundPhotos
      outboundReview
      outboundAdviceInputs
      outboundEventTypeId
      generatePickupNumber
      mustTarp
      verifyOutboundRailCar
      trackOutboundSeals
      inventoryCustomFields {
        id
        name
        type
        display
        required
      }
      inventoryPrimaryField
      inventoryPhotos
      trackInventorySeals
      isBarcodeRequired
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      bolTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      services {
        items {
          id
          owner
          groups
          active
          status
          reloadYardId
          accountName
          accountId
          name
          description
          unit
          pcs
          car
          tl
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          createdAt
          updatedAt
        }
        nextToken
      }
      checklists {
        items {
          id
          owner
          groups
          active
          reloadYardId
          resourceId
          name
          description
          processName
          reloadYardCommodityId
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      prompt
      createdAt
      updatedAt
    }
  }
`;
export const updateAccount = /* GraphQL */ `
  mutation UpdateAccount(
    $input: UpdateAccountInput!
    $condition: ModelAccountConditionInput
  ) {
    updateAccount(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      businessName
      displayName
      accountNumber
      externalId
      externalStatus
      accountType
      defaultBillToAccountId
      lotNumberPrefix
      color
      defaultWeightUOM
      paymentTermId
      paymentTerm {
        id
        owner
        groups
        reloadYardId
        name
        code
        type
        dueDays
        dayOfMonthDue
        sortKey
        createdAt
        updatedAt
      }
      creditLimit
      overLimit
      overDue
      einNumber
      skipInvoice
      email
      phone
      fax
      website
      address {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      billingAddress {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      contacts {
        name
        email
        phone
        description
      }
      billingContacts {
        name
        email
        phone
        description
      }
      billingEmail
      invoiceSubject
      invoiceAttachments
      invoiceCustomFields {
        id
        name
        type
        display
        required
      }
      addressState
      reloadYardId
      inboundCustomFields {
        id
        name
        type
        display
        required
      }
      inboundInstructions
      secondaryReview
      inboundSkipSignature
      inboundPhotos
      podEmail
      podPhotos
      podAttachments
      podSubject
      inboundAdviceInputs
      inboundEventTypeId
      lotType
      lotNumberOverride
      fifoLotNumber
      carlotLotNumber
      verifyInboundRailCar
      trackInboundSeals
      requireDefaultZone
      outboundCustomFields {
        id
        name
        type
        display
        required
      }
      outboundInstructions
      posEmail
      posPhotos
      posAttachments
      posSubject
      outboundSkipSignature
      outboundPhotos
      outboundReview
      outboundAdviceInputs
      outboundEventTypeId
      generatePickupNumber
      mustTarp
      verifyOutboundRailCar
      trackOutboundSeals
      inventoryCustomFields {
        id
        name
        type
        display
        required
      }
      inventoryPrimaryField
      inventoryPhotos
      trackInventorySeals
      isBarcodeRequired
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      bolTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      services {
        items {
          id
          owner
          groups
          active
          status
          reloadYardId
          accountName
          accountId
          name
          description
          unit
          pcs
          car
          tl
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          createdAt
          updatedAt
        }
        nextToken
      }
      checklists {
        items {
          id
          owner
          groups
          active
          reloadYardId
          resourceId
          name
          description
          processName
          reloadYardCommodityId
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      prompt
      createdAt
      updatedAt
    }
  }
`;
export const deleteAccount = /* GraphQL */ `
  mutation DeleteAccount(
    $input: DeleteAccountInput!
    $condition: ModelAccountConditionInput
  ) {
    deleteAccount(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      businessName
      displayName
      accountNumber
      externalId
      externalStatus
      accountType
      defaultBillToAccountId
      lotNumberPrefix
      color
      defaultWeightUOM
      paymentTermId
      paymentTerm {
        id
        owner
        groups
        reloadYardId
        name
        code
        type
        dueDays
        dayOfMonthDue
        sortKey
        createdAt
        updatedAt
      }
      creditLimit
      overLimit
      overDue
      einNumber
      skipInvoice
      email
      phone
      fax
      website
      address {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      billingAddress {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      contacts {
        name
        email
        phone
        description
      }
      billingContacts {
        name
        email
        phone
        description
      }
      billingEmail
      invoiceSubject
      invoiceAttachments
      invoiceCustomFields {
        id
        name
        type
        display
        required
      }
      addressState
      reloadYardId
      inboundCustomFields {
        id
        name
        type
        display
        required
      }
      inboundInstructions
      secondaryReview
      inboundSkipSignature
      inboundPhotos
      podEmail
      podPhotos
      podAttachments
      podSubject
      inboundAdviceInputs
      inboundEventTypeId
      lotType
      lotNumberOverride
      fifoLotNumber
      carlotLotNumber
      verifyInboundRailCar
      trackInboundSeals
      requireDefaultZone
      outboundCustomFields {
        id
        name
        type
        display
        required
      }
      outboundInstructions
      posEmail
      posPhotos
      posAttachments
      posSubject
      outboundSkipSignature
      outboundPhotos
      outboundReview
      outboundAdviceInputs
      outboundEventTypeId
      generatePickupNumber
      mustTarp
      verifyOutboundRailCar
      trackOutboundSeals
      inventoryCustomFields {
        id
        name
        type
        display
        required
      }
      inventoryPrimaryField
      inventoryPhotos
      trackInventorySeals
      isBarcodeRequired
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      bolTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      services {
        items {
          id
          owner
          groups
          active
          status
          reloadYardId
          accountName
          accountId
          name
          description
          unit
          pcs
          car
          tl
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          createdAt
          updatedAt
        }
        nextToken
      }
      checklists {
        items {
          id
          owner
          groups
          active
          reloadYardId
          resourceId
          name
          description
          processName
          reloadYardCommodityId
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      prompt
      createdAt
      updatedAt
    }
  }
`;
export const createAisle = /* GraphQL */ `
  mutation CreateAisle(
    $input: CreateAisleInput!
    $condition: ModelAisleConditionInput
  ) {
    createAisle(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      reloadYardId
      name
      type
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      locations {
        items {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        nextToken
      }
      bays
      levels
      positions
      totalLocations
      locationLoad {
        other {
          selected
          capacity
        }
        pallet {
          selected
          capacity
        }
        box {
          selected
          capacity
        }
        superSack {
          selected
          capacity
        }
        container {
          selected
          capacity
        }
        dryBulk {
          selected
          capacity
        }
        liquidBulk {
          selected
          capacity
        }
      }
      capacityUsed
      length
      width
      sortKey
      topDownPickOrder
      createdAt
      updatedAt
    }
  }
`;
export const updateAisle = /* GraphQL */ `
  mutation UpdateAisle(
    $input: UpdateAisleInput!
    $condition: ModelAisleConditionInput
  ) {
    updateAisle(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      reloadYardId
      name
      type
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      locations {
        items {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        nextToken
      }
      bays
      levels
      positions
      totalLocations
      locationLoad {
        other {
          selected
          capacity
        }
        pallet {
          selected
          capacity
        }
        box {
          selected
          capacity
        }
        superSack {
          selected
          capacity
        }
        container {
          selected
          capacity
        }
        dryBulk {
          selected
          capacity
        }
        liquidBulk {
          selected
          capacity
        }
      }
      capacityUsed
      length
      width
      sortKey
      topDownPickOrder
      createdAt
      updatedAt
    }
  }
`;
export const deleteAisle = /* GraphQL */ `
  mutation DeleteAisle(
    $input: DeleteAisleInput!
    $condition: ModelAisleConditionInput
  ) {
    deleteAisle(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      reloadYardId
      name
      type
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      locations {
        items {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        nextToken
      }
      bays
      levels
      positions
      totalLocations
      locationLoad {
        other {
          selected
          capacity
        }
        pallet {
          selected
          capacity
        }
        box {
          selected
          capacity
        }
        superSack {
          selected
          capacity
        }
        container {
          selected
          capacity
        }
        dryBulk {
          selected
          capacity
        }
        liquidBulk {
          selected
          capacity
        }
      }
      capacityUsed
      length
      width
      sortKey
      topDownPickOrder
      createdAt
      updatedAt
    }
  }
`;
export const createAnnouncement = /* GraphQL */ `
  mutation CreateAnnouncement(
    $input: CreateAnnouncementInput!
    $condition: ModelAnnouncementConditionInput
  ) {
    createAnnouncement(input: $input, condition: $condition) {
      id
      active
      activatedAt
      message
      urgency
      forceRefresh
      link
      tenantId
      createdAt
      updatedAt
    }
  }
`;
export const updateAnnouncement = /* GraphQL */ `
  mutation UpdateAnnouncement(
    $input: UpdateAnnouncementInput!
    $condition: ModelAnnouncementConditionInput
  ) {
    updateAnnouncement(input: $input, condition: $condition) {
      id
      active
      activatedAt
      message
      urgency
      forceRefresh
      link
      tenantId
      createdAt
      updatedAt
    }
  }
`;
export const deleteAnnouncement = /* GraphQL */ `
  mutation DeleteAnnouncement(
    $input: DeleteAnnouncementInput!
    $condition: ModelAnnouncementConditionInput
  ) {
    deleteAnnouncement(input: $input, condition: $condition) {
      id
      active
      activatedAt
      message
      urgency
      forceRefresh
      link
      tenantId
      createdAt
      updatedAt
    }
  }
`;
export const createApiKey = /* GraphQL */ `
  mutation CreateApiKey(
    $input: CreateApiKeyInput!
    $condition: ModelApiKeyConditionInput
  ) {
    createApiKey(input: $input, condition: $condition) {
      id
      active
      groups
      reloadYardId
      name
      keyId
      createdBy
      deletedBy
      createdAt
      updatedAt
    }
  }
`;
export const updateApiKey = /* GraphQL */ `
  mutation UpdateApiKey(
    $input: UpdateApiKeyInput!
    $condition: ModelApiKeyConditionInput
  ) {
    updateApiKey(input: $input, condition: $condition) {
      id
      active
      groups
      reloadYardId
      name
      keyId
      createdBy
      deletedBy
      createdAt
      updatedAt
    }
  }
`;
export const deleteApiKey = /* GraphQL */ `
  mutation DeleteApiKey(
    $input: DeleteApiKeyInput!
    $condition: ModelApiKeyConditionInput
  ) {
    deleteApiKey(input: $input, condition: $condition) {
      id
      active
      groups
      reloadYardId
      name
      keyId
      createdBy
      deletedBy
      createdAt
      updatedAt
    }
  }
`;
export const createArea = /* GraphQL */ `
  mutation CreateArea(
    $input: CreateAreaInput!
    $condition: ModelAreaConditionInput
  ) {
    createArea(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      reloadYardId
      name
      prefix
      color
      areaType
      sortKey
      zones {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateArea = /* GraphQL */ `
  mutation UpdateArea(
    $input: UpdateAreaInput!
    $condition: ModelAreaConditionInput
  ) {
    updateArea(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      reloadYardId
      name
      prefix
      color
      areaType
      sortKey
      zones {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteArea = /* GraphQL */ `
  mutation DeleteArea(
    $input: DeleteAreaInput!
    $condition: ModelAreaConditionInput
  ) {
    deleteArea(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      reloadYardId
      name
      prefix
      color
      areaType
      sortKey
      zones {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createAssetType = /* GraphQL */ `
  mutation CreateAssetType(
    $input: CreateAssetTypeInput!
    $condition: ModelAssetTypeConditionInput
  ) {
    createAssetType(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      reloadYardId
      areaId
      name
      maxConcurrentBookings
      createdAt
      updatedAt
    }
  }
`;
export const updateAssetType = /* GraphQL */ `
  mutation UpdateAssetType(
    $input: UpdateAssetTypeInput!
    $condition: ModelAssetTypeConditionInput
  ) {
    updateAssetType(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      reloadYardId
      areaId
      name
      maxConcurrentBookings
      createdAt
      updatedAt
    }
  }
`;
export const deleteAssetType = /* GraphQL */ `
  mutation DeleteAssetType(
    $input: DeleteAssetTypeInput!
    $condition: ModelAssetTypeConditionInput
  ) {
    deleteAssetType(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      reloadYardId
      areaId
      name
      maxConcurrentBookings
      createdAt
      updatedAt
    }
  }
`;
export const createAudit = /* GraphQL */ `
  mutation CreateAudit(
    $input: CreateAuditInput!
    $condition: ModelAuditConditionInput
  ) {
    createAudit(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      createdAt
      createDateTime
      notes
      reloadYardId
      processedItems
      processedLocations
      skippedItems
      nextItem
      nextItems {
        locationIdx
        owner
        name
      }
      direction
      accountId
      accountName
      assignedTo
      locations
      startDateTime
      endDateTime
      updatedAt
    }
  }
`;
export const updateAudit = /* GraphQL */ `
  mutation UpdateAudit(
    $input: UpdateAuditInput!
    $condition: ModelAuditConditionInput
  ) {
    updateAudit(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      createdAt
      createDateTime
      notes
      reloadYardId
      processedItems
      processedLocations
      skippedItems
      nextItem
      nextItems {
        locationIdx
        owner
        name
      }
      direction
      accountId
      accountName
      assignedTo
      locations
      startDateTime
      endDateTime
      updatedAt
    }
  }
`;
export const deleteAudit = /* GraphQL */ `
  mutation DeleteAudit(
    $input: DeleteAuditInput!
    $condition: ModelAuditConditionInput
  ) {
    deleteAudit(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      createdAt
      createDateTime
      notes
      reloadYardId
      processedItems
      processedLocations
      skippedItems
      nextItem
      nextItems {
        locationIdx
        owner
        name
      }
      direction
      accountId
      accountName
      assignedTo
      locations
      startDateTime
      endDateTime
      updatedAt
    }
  }
`;
export const createBarcode = /* GraphQL */ `
  mutation CreateBarcode(
    $input: CreateBarcodeInput!
    $condition: ModelBarcodeConditionInput
  ) {
    createBarcode(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      value
      isScanned
      scannedIn
      scannedOut
      reloadYardId
      inboundShipmentId
      inventoryId
      locationId
      inventoryItemId
      inventoryItem {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateBarcode = /* GraphQL */ `
  mutation UpdateBarcode(
    $input: UpdateBarcodeInput!
    $condition: ModelBarcodeConditionInput
  ) {
    updateBarcode(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      value
      isScanned
      scannedIn
      scannedOut
      reloadYardId
      inboundShipmentId
      inventoryId
      locationId
      inventoryItemId
      inventoryItem {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteBarcode = /* GraphQL */ `
  mutation DeleteBarcode(
    $input: DeleteBarcodeInput!
    $condition: ModelBarcodeConditionInput
  ) {
    deleteBarcode(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      value
      isScanned
      scannedIn
      scannedOut
      reloadYardId
      inboundShipmentId
      inventoryId
      locationId
      inventoryItemId
      inventoryItem {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createCapability = /* GraphQL */ `
  mutation CreateCapability(
    $input: CreateCapabilityInput!
    $condition: ModelCapabilityConditionInput
  ) {
    createCapability(input: $input, condition: $condition) {
      id
      active
      sortKey
      name
      description
      requiresValue
      requiredValueLabel
      quantity
      createdAt
      updatedAt
    }
  }
`;
export const updateCapability = /* GraphQL */ `
  mutation UpdateCapability(
    $input: UpdateCapabilityInput!
    $condition: ModelCapabilityConditionInput
  ) {
    updateCapability(input: $input, condition: $condition) {
      id
      active
      sortKey
      name
      description
      requiresValue
      requiredValueLabel
      quantity
      createdAt
      updatedAt
    }
  }
`;
export const deleteCapability = /* GraphQL */ `
  mutation DeleteCapability(
    $input: DeleteCapabilityInput!
    $condition: ModelCapabilityConditionInput
  ) {
    deleteCapability(input: $input, condition: $condition) {
      id
      active
      sortKey
      name
      description
      requiresValue
      requiredValueLabel
      quantity
      createdAt
      updatedAt
    }
  }
`;
export const createCarrier = /* GraphQL */ `
  mutation CreateCarrier(
    $input: CreateCarrierInput!
    $condition: ModelCarrierConditionInput
  ) {
    createCarrier(input: $input, condition: $condition) {
      id
      owner
      active
      groups
      businessName
      dbaName
      email
      phone
      normalizedEmail
      normalizedPhone
      identifiers {
        scheme
        value
      }
      companyId
      reloadYardId
      users {
        items {
          id
          owner
          groups
          active
          deleted
          carrierUserId
          carrierId
          reloadYardId
          businessName
          firstName
          lastName
          email
          phone
          type
          description
          acl
          notes
          blockAccess
          createdVia
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateCarrier = /* GraphQL */ `
  mutation UpdateCarrier(
    $input: UpdateCarrierInput!
    $condition: ModelCarrierConditionInput
  ) {
    updateCarrier(input: $input, condition: $condition) {
      id
      owner
      active
      groups
      businessName
      dbaName
      email
      phone
      normalizedEmail
      normalizedPhone
      identifiers {
        scheme
        value
      }
      companyId
      reloadYardId
      users {
        items {
          id
          owner
          groups
          active
          deleted
          carrierUserId
          carrierId
          reloadYardId
          businessName
          firstName
          lastName
          email
          phone
          type
          description
          acl
          notes
          blockAccess
          createdVia
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteCarrier = /* GraphQL */ `
  mutation DeleteCarrier(
    $input: DeleteCarrierInput!
    $condition: ModelCarrierConditionInput
  ) {
    deleteCarrier(input: $input, condition: $condition) {
      id
      owner
      active
      groups
      businessName
      dbaName
      email
      phone
      normalizedEmail
      normalizedPhone
      identifiers {
        scheme
        value
      }
      companyId
      reloadYardId
      users {
        items {
          id
          owner
          groups
          active
          deleted
          carrierUserId
          carrierId
          reloadYardId
          businessName
          firstName
          lastName
          email
          phone
          type
          description
          acl
          notes
          blockAccess
          createdVia
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createCarrierCompany = /* GraphQL */ `
  mutation CreateCarrierCompany(
    $input: CreateCarrierCompanyInput!
    $condition: ModelCarrierCompanyConditionInput
  ) {
    createCarrierCompany(input: $input, condition: $condition) {
      id
      groups
      businessName
      email
      phone
      normalizedEmail
      normalizedPhone
      identifiers {
        scheme
        value
      }
      yards {
        items {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateCarrierCompany = /* GraphQL */ `
  mutation UpdateCarrierCompany(
    $input: UpdateCarrierCompanyInput!
    $condition: ModelCarrierCompanyConditionInput
  ) {
    updateCarrierCompany(input: $input, condition: $condition) {
      id
      groups
      businessName
      email
      phone
      normalizedEmail
      normalizedPhone
      identifiers {
        scheme
        value
      }
      yards {
        items {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteCarrierCompany = /* GraphQL */ `
  mutation DeleteCarrierCompany(
    $input: DeleteCarrierCompanyInput!
    $condition: ModelCarrierCompanyConditionInput
  ) {
    deleteCarrierCompany(input: $input, condition: $condition) {
      id
      groups
      businessName
      email
      phone
      normalizedEmail
      normalizedPhone
      identifiers {
        scheme
        value
      }
      yards {
        items {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createCarrierUser = /* GraphQL */ `
  mutation CreateCarrierUser(
    $input: CreateCarrierUserInput!
    $condition: ModelCarrierUserConditionInput
  ) {
    createCarrierUser(input: $input, condition: $condition) {
      id
      status
      cognitoId
      email
      contactEmail
      unsubscribed
      firstName
      lastName
      phone
      userType
      driverCode
      suspendedAt
      suspendedBy
      suspensionReason
      reloadYardCarriers {
        items {
          id
          owner
          groups
          active
          deleted
          carrierUserId
          carrierId
          reloadYardId
          businessName
          firstName
          lastName
          email
          phone
          type
          description
          acl
          notes
          blockAccess
          createdVia
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateCarrierUser = /* GraphQL */ `
  mutation UpdateCarrierUser(
    $input: UpdateCarrierUserInput!
    $condition: ModelCarrierUserConditionInput
  ) {
    updateCarrierUser(input: $input, condition: $condition) {
      id
      status
      cognitoId
      email
      contactEmail
      unsubscribed
      firstName
      lastName
      phone
      userType
      driverCode
      suspendedAt
      suspendedBy
      suspensionReason
      reloadYardCarriers {
        items {
          id
          owner
          groups
          active
          deleted
          carrierUserId
          carrierId
          reloadYardId
          businessName
          firstName
          lastName
          email
          phone
          type
          description
          acl
          notes
          blockAccess
          createdVia
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteCarrierUser = /* GraphQL */ `
  mutation DeleteCarrierUser(
    $input: DeleteCarrierUserInput!
    $condition: ModelCarrierUserConditionInput
  ) {
    deleteCarrierUser(input: $input, condition: $condition) {
      id
      status
      cognitoId
      email
      contactEmail
      unsubscribed
      firstName
      lastName
      phone
      userType
      driverCode
      suspendedAt
      suspendedBy
      suspensionReason
      reloadYardCarriers {
        items {
          id
          owner
          groups
          active
          deleted
          carrierUserId
          carrierId
          reloadYardId
          businessName
          firstName
          lastName
          email
          phone
          type
          description
          acl
          notes
          blockAccess
          createdVia
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createCarrierUserReloadYardCarrier = /* GraphQL */ `
  mutation CreateCarrierUserReloadYardCarrier(
    $input: CreateCarrierUserReloadYardCarrierInput!
    $condition: ModelCarrierUserReloadYardCarrierConditionInput
  ) {
    createCarrierUserReloadYardCarrier(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      deleted
      carrierUserId
      user {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      carrierId
      carrier {
        id
        owner
        active
        groups
        businessName
        dbaName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        companyId
        reloadYardId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      reloadYardId
      reloadYard {
        id
        owner
        groups
        active
        status
        name
        phone
        fax
        email
        website
        street
        city
        state
        zipCode
        country
        latitude
        longitude
        geofence
        geofenceToleranceMeters
        geofenceEnabled
        geofenceEnforced
        driverCheckInEnabled
        driverIdentificationRequired
        driverIdScanRequired
        driverCheckInGraceMinutes
        driverCheckInWithoutAppointment
        driverInstructions
        postCheckInMessage
        driverStops {
          label
          message
        }
        driverIdImageRetention
        lotCapacity
        trackCapacity
        warehouseCapacity
        servingCarrier
        railHighway
        ast
        externalCompanyId
        taxRates {
          taxCode
          name
          taxRate
        }
        paymentTerms {
          nextToken
        }
        invoiceNumberPrefix
        invoiceCounter
        remittanceAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolCounter
        receiptCounter
        fileCategories {
          key
          name
        }
        mapImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        logoImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        areas {
          nextToken
        }
        zones {
          nextToken
        }
        aisles {
          nextToken
        }
        yardCommodities {
          nextToken
        }
        subscription {
          customerId
          subscriptionId
          priceId
          name
          status
        }
        tosAccept {
          acceptTimeStamp
          cognitoId
          email
          userAgent
          ip
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        timeZone
        railEquipmentTypes {
          nextToken
        }
        truckEquipmentTypes {
          nextToken
        }
        assetTypes {
          nextToken
        }
        eventTypes {
          nextToken
        }
        checklists {
          nextToken
        }
        apiKeys {
          nextToken
        }
        invoicesProcessedAt
        reportsProcessedAt
        createdAt
        updatedAt
      }
      businessName
      firstName
      lastName
      email
      phone
      type
      description
      acl
      photo {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      notes
      blockAccess
      createdVia
      createdAt
      updatedAt
    }
  }
`;
export const updateCarrierUserReloadYardCarrier = /* GraphQL */ `
  mutation UpdateCarrierUserReloadYardCarrier(
    $input: UpdateCarrierUserReloadYardCarrierInput!
    $condition: ModelCarrierUserReloadYardCarrierConditionInput
  ) {
    updateCarrierUserReloadYardCarrier(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      deleted
      carrierUserId
      user {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      carrierId
      carrier {
        id
        owner
        active
        groups
        businessName
        dbaName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        companyId
        reloadYardId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      reloadYardId
      reloadYard {
        id
        owner
        groups
        active
        status
        name
        phone
        fax
        email
        website
        street
        city
        state
        zipCode
        country
        latitude
        longitude
        geofence
        geofenceToleranceMeters
        geofenceEnabled
        geofenceEnforced
        driverCheckInEnabled
        driverIdentificationRequired
        driverIdScanRequired
        driverCheckInGraceMinutes
        driverCheckInWithoutAppointment
        driverInstructions
        postCheckInMessage
        driverStops {
          label
          message
        }
        driverIdImageRetention
        lotCapacity
        trackCapacity
        warehouseCapacity
        servingCarrier
        railHighway
        ast
        externalCompanyId
        taxRates {
          taxCode
          name
          taxRate
        }
        paymentTerms {
          nextToken
        }
        invoiceNumberPrefix
        invoiceCounter
        remittanceAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolCounter
        receiptCounter
        fileCategories {
          key
          name
        }
        mapImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        logoImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        areas {
          nextToken
        }
        zones {
          nextToken
        }
        aisles {
          nextToken
        }
        yardCommodities {
          nextToken
        }
        subscription {
          customerId
          subscriptionId
          priceId
          name
          status
        }
        tosAccept {
          acceptTimeStamp
          cognitoId
          email
          userAgent
          ip
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        timeZone
        railEquipmentTypes {
          nextToken
        }
        truckEquipmentTypes {
          nextToken
        }
        assetTypes {
          nextToken
        }
        eventTypes {
          nextToken
        }
        checklists {
          nextToken
        }
        apiKeys {
          nextToken
        }
        invoicesProcessedAt
        reportsProcessedAt
        createdAt
        updatedAt
      }
      businessName
      firstName
      lastName
      email
      phone
      type
      description
      acl
      photo {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      notes
      blockAccess
      createdVia
      createdAt
      updatedAt
    }
  }
`;
export const deleteCarrierUserReloadYardCarrier = /* GraphQL */ `
  mutation DeleteCarrierUserReloadYardCarrier(
    $input: DeleteCarrierUserReloadYardCarrierInput!
    $condition: ModelCarrierUserReloadYardCarrierConditionInput
  ) {
    deleteCarrierUserReloadYardCarrier(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      deleted
      carrierUserId
      user {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      carrierId
      carrier {
        id
        owner
        active
        groups
        businessName
        dbaName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        companyId
        reloadYardId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      reloadYardId
      reloadYard {
        id
        owner
        groups
        active
        status
        name
        phone
        fax
        email
        website
        street
        city
        state
        zipCode
        country
        latitude
        longitude
        geofence
        geofenceToleranceMeters
        geofenceEnabled
        geofenceEnforced
        driverCheckInEnabled
        driverIdentificationRequired
        driverIdScanRequired
        driverCheckInGraceMinutes
        driverCheckInWithoutAppointment
        driverInstructions
        postCheckInMessage
        driverStops {
          label
          message
        }
        driverIdImageRetention
        lotCapacity
        trackCapacity
        warehouseCapacity
        servingCarrier
        railHighway
        ast
        externalCompanyId
        taxRates {
          taxCode
          name
          taxRate
        }
        paymentTerms {
          nextToken
        }
        invoiceNumberPrefix
        invoiceCounter
        remittanceAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolCounter
        receiptCounter
        fileCategories {
          key
          name
        }
        mapImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        logoImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        areas {
          nextToken
        }
        zones {
          nextToken
        }
        aisles {
          nextToken
        }
        yardCommodities {
          nextToken
        }
        subscription {
          customerId
          subscriptionId
          priceId
          name
          status
        }
        tosAccept {
          acceptTimeStamp
          cognitoId
          email
          userAgent
          ip
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        timeZone
        railEquipmentTypes {
          nextToken
        }
        truckEquipmentTypes {
          nextToken
        }
        assetTypes {
          nextToken
        }
        eventTypes {
          nextToken
        }
        checklists {
          nextToken
        }
        apiKeys {
          nextToken
        }
        invoicesProcessedAt
        reportsProcessedAt
        createdAt
        updatedAt
      }
      businessName
      firstName
      lastName
      email
      phone
      type
      description
      acl
      photo {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      notes
      blockAccess
      createdVia
      createdAt
      updatedAt
    }
  }
`;
export const createChargeRule = /* GraphQL */ `
  mutation CreateChargeRule(
    $input: CreateChargeRuleInput!
    $condition: ModelChargeRuleConditionInput
  ) {
    createChargeRule(input: $input, condition: $condition) {
      id
      owner
      active
      groups
      accountId
      reloadYardId
      event
      serviceId
      service {
        id
        owner
        groups
        active
        status
        reloadYardId
        accountName
        accountId
        name
        description
        taxRate {
          taxCode
          name
          taxRate
        }
        unit
        pcs
        car
        tl
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        createdAt
        updatedAt
      }
      billingUOM
      reloadYardCommodityId
      carrierType
      carrierEquipmentTypeId
      areaId
      zoneId
      graduatedRates {
        days
        rate
      }
      minCharge
      maxCharge
      execution
      frequency
      feeAccrual
      freeDaysPolicy
      freeDays
      freeCars
      createdAt
      updatedAt
    }
  }
`;
export const updateChargeRule = /* GraphQL */ `
  mutation UpdateChargeRule(
    $input: UpdateChargeRuleInput!
    $condition: ModelChargeRuleConditionInput
  ) {
    updateChargeRule(input: $input, condition: $condition) {
      id
      owner
      active
      groups
      accountId
      reloadYardId
      event
      serviceId
      service {
        id
        owner
        groups
        active
        status
        reloadYardId
        accountName
        accountId
        name
        description
        taxRate {
          taxCode
          name
          taxRate
        }
        unit
        pcs
        car
        tl
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        createdAt
        updatedAt
      }
      billingUOM
      reloadYardCommodityId
      carrierType
      carrierEquipmentTypeId
      areaId
      zoneId
      graduatedRates {
        days
        rate
      }
      minCharge
      maxCharge
      execution
      frequency
      feeAccrual
      freeDaysPolicy
      freeDays
      freeCars
      createdAt
      updatedAt
    }
  }
`;
export const deleteChargeRule = /* GraphQL */ `
  mutation DeleteChargeRule(
    $input: DeleteChargeRuleInput!
    $condition: ModelChargeRuleConditionInput
  ) {
    deleteChargeRule(input: $input, condition: $condition) {
      id
      owner
      active
      groups
      accountId
      reloadYardId
      event
      serviceId
      service {
        id
        owner
        groups
        active
        status
        reloadYardId
        accountName
        accountId
        name
        description
        taxRate {
          taxCode
          name
          taxRate
        }
        unit
        pcs
        car
        tl
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        createdAt
        updatedAt
      }
      billingUOM
      reloadYardCommodityId
      carrierType
      carrierEquipmentTypeId
      areaId
      zoneId
      graduatedRates {
        days
        rate
      }
      minCharge
      maxCharge
      execution
      frequency
      feeAccrual
      freeDaysPolicy
      freeDays
      freeCars
      createdAt
      updatedAt
    }
  }
`;
export const createChecklist = /* GraphQL */ `
  mutation CreateChecklist(
    $input: CreateChecklistInput!
    $condition: ModelChecklistConditionInput
  ) {
    createChecklist(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      reloadYardId
      resourceId
      name
      description
      processName
      checklistItems {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      reloadYardCommodityId
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const updateChecklist = /* GraphQL */ `
  mutation UpdateChecklist(
    $input: UpdateChecklistInput!
    $condition: ModelChecklistConditionInput
  ) {
    updateChecklist(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      reloadYardId
      resourceId
      name
      description
      processName
      checklistItems {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      reloadYardCommodityId
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const deleteChecklist = /* GraphQL */ `
  mutation DeleteChecklist(
    $input: DeleteChecklistInput!
    $condition: ModelChecklistConditionInput
  ) {
    deleteChecklist(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      reloadYardId
      resourceId
      name
      description
      processName
      checklistItems {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      reloadYardCommodityId
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const createCommodity = /* GraphQL */ `
  mutation CreateCommodity(
    $input: CreateCommodityInput!
    $condition: ModelCommodityConditionInput
  ) {
    createCommodity(input: $input, condition: $condition) {
      id
      active
      sortKey
      name
      description
      defaultUnits
      locationLoadType
      validUom
      inventoryFields
      enableCounter
      prompt
      createdAt
      updatedAt
    }
  }
`;
export const updateCommodity = /* GraphQL */ `
  mutation UpdateCommodity(
    $input: UpdateCommodityInput!
    $condition: ModelCommodityConditionInput
  ) {
    updateCommodity(input: $input, condition: $condition) {
      id
      active
      sortKey
      name
      description
      defaultUnits
      locationLoadType
      validUom
      inventoryFields
      enableCounter
      prompt
      createdAt
      updatedAt
    }
  }
`;
export const deleteCommodity = /* GraphQL */ `
  mutation DeleteCommodity(
    $input: DeleteCommodityInput!
    $condition: ModelCommodityConditionInput
  ) {
    deleteCommodity(input: $input, condition: $condition) {
      id
      active
      sortKey
      name
      description
      defaultUnits
      locationLoadType
      validUom
      inventoryFields
      enableCounter
      prompt
      createdAt
      updatedAt
    }
  }
`;
export const createCustomer = /* GraphQL */ `
  mutation CreateCustomer(
    $input: CreateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    createCustomer(input: $input, condition: $condition) {
      id
      status
      cognitoId
      email
      unsubscribed
      firstName
      lastName
      phone
      reloadYardAccounts {
        items {
          id
          owner
          active
          groups
          email
          lastName
          acl
          description
          customerId
          reloadYardId
          accountId
          accountName
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateCustomer = /* GraphQL */ `
  mutation UpdateCustomer(
    $input: UpdateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    updateCustomer(input: $input, condition: $condition) {
      id
      status
      cognitoId
      email
      unsubscribed
      firstName
      lastName
      phone
      reloadYardAccounts {
        items {
          id
          owner
          active
          groups
          email
          lastName
          acl
          description
          customerId
          reloadYardId
          accountId
          accountName
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteCustomer = /* GraphQL */ `
  mutation DeleteCustomer(
    $input: DeleteCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    deleteCustomer(input: $input, condition: $condition) {
      id
      status
      cognitoId
      email
      unsubscribed
      firstName
      lastName
      phone
      reloadYardAccounts {
        items {
          id
          owner
          active
          groups
          email
          lastName
          acl
          description
          customerId
          reloadYardId
          accountId
          accountName
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createCustomerReloadYardAccount = /* GraphQL */ `
  mutation CreateCustomerReloadYardAccount(
    $input: CreateCustomerReloadYardAccountInput!
    $condition: ModelCustomerReloadYardAccountConditionInput
  ) {
    createCustomerReloadYardAccount(input: $input, condition: $condition) {
      id
      owner
      active
      groups
      email
      lastName
      acl
      description
      customerId
      customer {
        id
        status
        cognitoId
        email
        unsubscribed
        firstName
        lastName
        phone
        reloadYardAccounts {
          nextToken
        }
        createdAt
        updatedAt
      }
      reloadYardId
      reloadYard {
        id
        owner
        groups
        active
        status
        name
        phone
        fax
        email
        website
        street
        city
        state
        zipCode
        country
        latitude
        longitude
        geofence
        geofenceToleranceMeters
        geofenceEnabled
        geofenceEnforced
        driverCheckInEnabled
        driverIdentificationRequired
        driverIdScanRequired
        driverCheckInGraceMinutes
        driverCheckInWithoutAppointment
        driverInstructions
        postCheckInMessage
        driverStops {
          label
          message
        }
        driverIdImageRetention
        lotCapacity
        trackCapacity
        warehouseCapacity
        servingCarrier
        railHighway
        ast
        externalCompanyId
        taxRates {
          taxCode
          name
          taxRate
        }
        paymentTerms {
          nextToken
        }
        invoiceNumberPrefix
        invoiceCounter
        remittanceAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolCounter
        receiptCounter
        fileCategories {
          key
          name
        }
        mapImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        logoImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        areas {
          nextToken
        }
        zones {
          nextToken
        }
        aisles {
          nextToken
        }
        yardCommodities {
          nextToken
        }
        subscription {
          customerId
          subscriptionId
          priceId
          name
          status
        }
        tosAccept {
          acceptTimeStamp
          cognitoId
          email
          userAgent
          ip
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        timeZone
        railEquipmentTypes {
          nextToken
        }
        truckEquipmentTypes {
          nextToken
        }
        assetTypes {
          nextToken
        }
        eventTypes {
          nextToken
        }
        checklists {
          nextToken
        }
        apiKeys {
          nextToken
        }
        invoicesProcessedAt
        reportsProcessedAt
        createdAt
        updatedAt
      }
      accountId
      accountName
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateCustomerReloadYardAccount = /* GraphQL */ `
  mutation UpdateCustomerReloadYardAccount(
    $input: UpdateCustomerReloadYardAccountInput!
    $condition: ModelCustomerReloadYardAccountConditionInput
  ) {
    updateCustomerReloadYardAccount(input: $input, condition: $condition) {
      id
      owner
      active
      groups
      email
      lastName
      acl
      description
      customerId
      customer {
        id
        status
        cognitoId
        email
        unsubscribed
        firstName
        lastName
        phone
        reloadYardAccounts {
          nextToken
        }
        createdAt
        updatedAt
      }
      reloadYardId
      reloadYard {
        id
        owner
        groups
        active
        status
        name
        phone
        fax
        email
        website
        street
        city
        state
        zipCode
        country
        latitude
        longitude
        geofence
        geofenceToleranceMeters
        geofenceEnabled
        geofenceEnforced
        driverCheckInEnabled
        driverIdentificationRequired
        driverIdScanRequired
        driverCheckInGraceMinutes
        driverCheckInWithoutAppointment
        driverInstructions
        postCheckInMessage
        driverStops {
          label
          message
        }
        driverIdImageRetention
        lotCapacity
        trackCapacity
        warehouseCapacity
        servingCarrier
        railHighway
        ast
        externalCompanyId
        taxRates {
          taxCode
          name
          taxRate
        }
        paymentTerms {
          nextToken
        }
        invoiceNumberPrefix
        invoiceCounter
        remittanceAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolCounter
        receiptCounter
        fileCategories {
          key
          name
        }
        mapImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        logoImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        areas {
          nextToken
        }
        zones {
          nextToken
        }
        aisles {
          nextToken
        }
        yardCommodities {
          nextToken
        }
        subscription {
          customerId
          subscriptionId
          priceId
          name
          status
        }
        tosAccept {
          acceptTimeStamp
          cognitoId
          email
          userAgent
          ip
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        timeZone
        railEquipmentTypes {
          nextToken
        }
        truckEquipmentTypes {
          nextToken
        }
        assetTypes {
          nextToken
        }
        eventTypes {
          nextToken
        }
        checklists {
          nextToken
        }
        apiKeys {
          nextToken
        }
        invoicesProcessedAt
        reportsProcessedAt
        createdAt
        updatedAt
      }
      accountId
      accountName
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteCustomerReloadYardAccount = /* GraphQL */ `
  mutation DeleteCustomerReloadYardAccount(
    $input: DeleteCustomerReloadYardAccountInput!
    $condition: ModelCustomerReloadYardAccountConditionInput
  ) {
    deleteCustomerReloadYardAccount(input: $input, condition: $condition) {
      id
      owner
      active
      groups
      email
      lastName
      acl
      description
      customerId
      customer {
        id
        status
        cognitoId
        email
        unsubscribed
        firstName
        lastName
        phone
        reloadYardAccounts {
          nextToken
        }
        createdAt
        updatedAt
      }
      reloadYardId
      reloadYard {
        id
        owner
        groups
        active
        status
        name
        phone
        fax
        email
        website
        street
        city
        state
        zipCode
        country
        latitude
        longitude
        geofence
        geofenceToleranceMeters
        geofenceEnabled
        geofenceEnforced
        driverCheckInEnabled
        driverIdentificationRequired
        driverIdScanRequired
        driverCheckInGraceMinutes
        driverCheckInWithoutAppointment
        driverInstructions
        postCheckInMessage
        driverStops {
          label
          message
        }
        driverIdImageRetention
        lotCapacity
        trackCapacity
        warehouseCapacity
        servingCarrier
        railHighway
        ast
        externalCompanyId
        taxRates {
          taxCode
          name
          taxRate
        }
        paymentTerms {
          nextToken
        }
        invoiceNumberPrefix
        invoiceCounter
        remittanceAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolCounter
        receiptCounter
        fileCategories {
          key
          name
        }
        mapImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        logoImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        areas {
          nextToken
        }
        zones {
          nextToken
        }
        aisles {
          nextToken
        }
        yardCommodities {
          nextToken
        }
        subscription {
          customerId
          subscriptionId
          priceId
          name
          status
        }
        tosAccept {
          acceptTimeStamp
          cognitoId
          email
          userAgent
          ip
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        timeZone
        railEquipmentTypes {
          nextToken
        }
        truckEquipmentTypes {
          nextToken
        }
        assetTypes {
          nextToken
        }
        eventTypes {
          nextToken
        }
        checklists {
          nextToken
        }
        apiKeys {
          nextToken
        }
        invoicesProcessedAt
        reportsProcessedAt
        createdAt
        updatedAt
      }
      accountId
      accountName
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createEventType = /* GraphQL */ `
  mutation CreateEventType(
    $input: CreateEventTypeInput!
    $condition: ModelEventTypeConditionInput
  ) {
    createEventType(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      reloadYardId
      areaId
      name
      description
      schedule {
        workdays {
          id
          name
          startDayTime
          endDayTime
          selected
        }
        holidays
        minNoticeHours
        maxDaysIntoFuture
        layout
      }
      duration
      bufferTime
      resourceName
      numberOfResources
      assetTypeId
      assetType {
        id
        owner
        groups
        active
        reloadYardId
        areaId
        name
        maxConcurrentBookings
        createdAt
        updatedAt
      }
      workflow
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateEventType = /* GraphQL */ `
  mutation UpdateEventType(
    $input: UpdateEventTypeInput!
    $condition: ModelEventTypeConditionInput
  ) {
    updateEventType(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      reloadYardId
      areaId
      name
      description
      schedule {
        workdays {
          id
          name
          startDayTime
          endDayTime
          selected
        }
        holidays
        minNoticeHours
        maxDaysIntoFuture
        layout
      }
      duration
      bufferTime
      resourceName
      numberOfResources
      assetTypeId
      assetType {
        id
        owner
        groups
        active
        reloadYardId
        areaId
        name
        maxConcurrentBookings
        createdAt
        updatedAt
      }
      workflow
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteEventType = /* GraphQL */ `
  mutation DeleteEventType(
    $input: DeleteEventTypeInput!
    $condition: ModelEventTypeConditionInput
  ) {
    deleteEventType(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      reloadYardId
      areaId
      name
      description
      schedule {
        workdays {
          id
          name
          startDayTime
          endDayTime
          selected
        }
        holidays
        minNoticeHours
        maxDaysIntoFuture
        layout
      }
      duration
      bufferTime
      resourceName
      numberOfResources
      assetTypeId
      assetType {
        id
        owner
        groups
        active
        reloadYardId
        areaId
        name
        maxConcurrentBookings
        createdAt
        updatedAt
      }
      workflow
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createFile = /* GraphQL */ `
  mutation CreateFile(
    $input: CreateFileInput!
    $condition: ModelFileConditionInput
  ) {
    createFile(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      reloadYardId
      displayName
      rawFileName
      description
      contentDate
      category
      visibility
      file {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateFile = /* GraphQL */ `
  mutation UpdateFile(
    $input: UpdateFileInput!
    $condition: ModelFileConditionInput
  ) {
    updateFile(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      reloadYardId
      displayName
      rawFileName
      description
      contentDate
      category
      visibility
      file {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteFile = /* GraphQL */ `
  mutation DeleteFile(
    $input: DeleteFileInput!
    $condition: ModelFileConditionInput
  ) {
    deleteFile(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      reloadYardId
      displayName
      rawFileName
      description
      contentDate
      category
      visibility
      file {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createHelpPage = /* GraphQL */ `
  mutation CreateHelpPage(
    $input: CreateHelpPageInput!
    $condition: ModelHelpPageConditionInput
  ) {
    createHelpPage(input: $input, condition: $condition) {
      id
      active
      isLive
      url
      topic
      name
      content
      kbFiles {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      kbMedia {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      kbContent {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const updateHelpPage = /* GraphQL */ `
  mutation UpdateHelpPage(
    $input: UpdateHelpPageInput!
    $condition: ModelHelpPageConditionInput
  ) {
    updateHelpPage(input: $input, condition: $condition) {
      id
      active
      isLive
      url
      topic
      name
      content
      kbFiles {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      kbMedia {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      kbContent {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const deleteHelpPage = /* GraphQL */ `
  mutation DeleteHelpPage(
    $input: DeleteHelpPageInput!
    $condition: ModelHelpPageConditionInput
  ) {
    deleteHelpPage(input: $input, condition: $condition) {
      id
      active
      isLive
      url
      topic
      name
      content
      kbFiles {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      kbMedia {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      kbContent {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const createHistoryNote = /* GraphQL */ `
  mutation CreateHistoryNote(
    $input: CreateHistoryNoteInput!
    $condition: ModelHistoryNoteConditionInput
  ) {
    createHistoryNote(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      parentId
      parentType
      text
      dateTime
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const updateHistoryNote = /* GraphQL */ `
  mutation UpdateHistoryNote(
    $input: UpdateHistoryNoteInput!
    $condition: ModelHistoryNoteConditionInput
  ) {
    updateHistoryNote(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      parentId
      parentType
      text
      dateTime
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const deleteHistoryNote = /* GraphQL */ `
  mutation DeleteHistoryNote(
    $input: DeleteHistoryNoteInput!
    $condition: ModelHistoryNoteConditionInput
  ) {
    deleteHistoryNote(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      parentId
      parentType
      text
      dateTime
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const createInboundShipment = /* GraphQL */ `
  mutation CreateInboundShipment(
    $input: CreateInboundShipmentInput!
    $condition: ModelInboundShipmentConditionInput
  ) {
    createInboundShipment(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      state
      poNumber
      normalizedPoNumber
      lotNumber
      lotNumberOverride
      shipFrom
      carrierType
      originCarrier
      carrierName
      carrierId
      carrier {
        id
        owner
        active
        groups
        businessName
        dbaName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        companyId
        reloadYardId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      driverId
      driver {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      driverName
      lotType
      railCarNumber
      normalizedRailCarNumber
      carrierEquipmentTypeId
      railEquipmentType {
        id
        owner
        groups
        active
        name
        arrTypeCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      truckEquipmentType {
        id
        owner
        groups
        active
        name
        dotSpecCode
        dotClassCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      totalUOM
      skipInvoice
      tareWeight
      ladenWeight
      weightUnits
      netWeight
      scaleWeightUnits
      skipSignature
      yardSignatureKey
      carrierSignatureKey
      signedBy
      advisedBy
      createDateTime
      scheduledDateTime
      notifyDateTime
      placedDateTime
      startDateTime
      endDateTime
      releaseDateTime
      collectedDateTime
      stripeBillingDateTime
      daysOnDemurrageClock
      photos {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          bucket
          region
          key
          type
          name
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptFile {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptNumber
      assignedTo
      workflowType
      unloadedBy
      reviewedBy
      secondaryReview
      verificationRequired
      stockImport
      sit
      returnShipment
      returnOutboundShipmentId
      returnReason
      hasException
      unsafeShipment
      unsafeShipmentNote
      brokenSeal
      brokenSealNote
      otherException
      otherExceptionNote
      instructions
      checklistId
      checklist {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      accountName
      accountId
      billToAccountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      billToAccount {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      inventories {
        items {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        nextToken
      }
      manualCharges {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          chargeRuleId
          quantity
          sortKey
          invoiceServiceId
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      invoicedServices {
        items {
          id
          owner
          groups
          invoiceId
          serviceId
          event
          externalId
          sortKey
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          quantity
          units
          unitCost
          amount
          itemTax
          itemTotal
          serviceNote
          serviceDate
          createdAt
          updatedAt
        }
        nextToken
      }
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      trackCar {
        id
        active
        owner
        areaId
        zoneId
        aisleId
        trackId
        eodTrackId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        locationFullName
        reloadYardId
        accountId
        shipmentId
        parentType
        inbound {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outbound {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        railCarNumber
        sortKey
        eodSortKey
        movementLogs {
          trackCarId
          sortKey
          movedAt
          movedBy
        }
        updatedAt
        updatedBy
        createdAt
      }
      isCollected
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      containerDrop
      containerNumber
      customFields
      selectedCustomFields {
        id
        name
        type
        display
        required
      }
      timeslotId
      gateCheckInId
      timeslot {
        id
        owner
        groups
        status
        reloadYardId
        year
        month
        week
        day
        time
        startTime
        endTime
        inboundId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        accountName
        accountId
        eventTypeId
        eventType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          workflow
          reloadYardCommodityId
          createdAt
          updatedAt
        }
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        carrierUserId
        carrierUser {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      stepName
      sealNumbers
      seals {
        items {
          id
          active
          owner
          groups
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          isScanned
          createdAt
          createdBy
          validated
          reValidated
          brokenAt
          brokenBy
          description
          status
          updatedAt
        }
        nextToken
      }
      braData {
        id
        owner
        groups
        reloadYardId
        accountId
        braSessionId
        braRawData
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateInboundShipment = /* GraphQL */ `
  mutation UpdateInboundShipment(
    $input: UpdateInboundShipmentInput!
    $condition: ModelInboundShipmentConditionInput
  ) {
    updateInboundShipment(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      state
      poNumber
      normalizedPoNumber
      lotNumber
      lotNumberOverride
      shipFrom
      carrierType
      originCarrier
      carrierName
      carrierId
      carrier {
        id
        owner
        active
        groups
        businessName
        dbaName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        companyId
        reloadYardId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      driverId
      driver {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      driverName
      lotType
      railCarNumber
      normalizedRailCarNumber
      carrierEquipmentTypeId
      railEquipmentType {
        id
        owner
        groups
        active
        name
        arrTypeCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      truckEquipmentType {
        id
        owner
        groups
        active
        name
        dotSpecCode
        dotClassCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      totalUOM
      skipInvoice
      tareWeight
      ladenWeight
      weightUnits
      netWeight
      scaleWeightUnits
      skipSignature
      yardSignatureKey
      carrierSignatureKey
      signedBy
      advisedBy
      createDateTime
      scheduledDateTime
      notifyDateTime
      placedDateTime
      startDateTime
      endDateTime
      releaseDateTime
      collectedDateTime
      stripeBillingDateTime
      daysOnDemurrageClock
      photos {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          bucket
          region
          key
          type
          name
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptFile {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptNumber
      assignedTo
      workflowType
      unloadedBy
      reviewedBy
      secondaryReview
      verificationRequired
      stockImport
      sit
      returnShipment
      returnOutboundShipmentId
      returnReason
      hasException
      unsafeShipment
      unsafeShipmentNote
      brokenSeal
      brokenSealNote
      otherException
      otherExceptionNote
      instructions
      checklistId
      checklist {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      accountName
      accountId
      billToAccountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      billToAccount {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      inventories {
        items {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        nextToken
      }
      manualCharges {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          chargeRuleId
          quantity
          sortKey
          invoiceServiceId
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      invoicedServices {
        items {
          id
          owner
          groups
          invoiceId
          serviceId
          event
          externalId
          sortKey
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          quantity
          units
          unitCost
          amount
          itemTax
          itemTotal
          serviceNote
          serviceDate
          createdAt
          updatedAt
        }
        nextToken
      }
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      trackCar {
        id
        active
        owner
        areaId
        zoneId
        aisleId
        trackId
        eodTrackId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        locationFullName
        reloadYardId
        accountId
        shipmentId
        parentType
        inbound {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outbound {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        railCarNumber
        sortKey
        eodSortKey
        movementLogs {
          trackCarId
          sortKey
          movedAt
          movedBy
        }
        updatedAt
        updatedBy
        createdAt
      }
      isCollected
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      containerDrop
      containerNumber
      customFields
      selectedCustomFields {
        id
        name
        type
        display
        required
      }
      timeslotId
      gateCheckInId
      timeslot {
        id
        owner
        groups
        status
        reloadYardId
        year
        month
        week
        day
        time
        startTime
        endTime
        inboundId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        accountName
        accountId
        eventTypeId
        eventType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          workflow
          reloadYardCommodityId
          createdAt
          updatedAt
        }
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        carrierUserId
        carrierUser {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      stepName
      sealNumbers
      seals {
        items {
          id
          active
          owner
          groups
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          isScanned
          createdAt
          createdBy
          validated
          reValidated
          brokenAt
          brokenBy
          description
          status
          updatedAt
        }
        nextToken
      }
      braData {
        id
        owner
        groups
        reloadYardId
        accountId
        braSessionId
        braRawData
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteInboundShipment = /* GraphQL */ `
  mutation DeleteInboundShipment(
    $input: DeleteInboundShipmentInput!
    $condition: ModelInboundShipmentConditionInput
  ) {
    deleteInboundShipment(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      state
      poNumber
      normalizedPoNumber
      lotNumber
      lotNumberOverride
      shipFrom
      carrierType
      originCarrier
      carrierName
      carrierId
      carrier {
        id
        owner
        active
        groups
        businessName
        dbaName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        companyId
        reloadYardId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      driverId
      driver {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      driverName
      lotType
      railCarNumber
      normalizedRailCarNumber
      carrierEquipmentTypeId
      railEquipmentType {
        id
        owner
        groups
        active
        name
        arrTypeCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      truckEquipmentType {
        id
        owner
        groups
        active
        name
        dotSpecCode
        dotClassCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      totalUOM
      skipInvoice
      tareWeight
      ladenWeight
      weightUnits
      netWeight
      scaleWeightUnits
      skipSignature
      yardSignatureKey
      carrierSignatureKey
      signedBy
      advisedBy
      createDateTime
      scheduledDateTime
      notifyDateTime
      placedDateTime
      startDateTime
      endDateTime
      releaseDateTime
      collectedDateTime
      stripeBillingDateTime
      daysOnDemurrageClock
      photos {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          bucket
          region
          key
          type
          name
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptFile {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptNumber
      assignedTo
      workflowType
      unloadedBy
      reviewedBy
      secondaryReview
      verificationRequired
      stockImport
      sit
      returnShipment
      returnOutboundShipmentId
      returnReason
      hasException
      unsafeShipment
      unsafeShipmentNote
      brokenSeal
      brokenSealNote
      otherException
      otherExceptionNote
      instructions
      checklistId
      checklist {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      accountName
      accountId
      billToAccountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      billToAccount {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      inventories {
        items {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        nextToken
      }
      manualCharges {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          chargeRuleId
          quantity
          sortKey
          invoiceServiceId
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      invoicedServices {
        items {
          id
          owner
          groups
          invoiceId
          serviceId
          event
          externalId
          sortKey
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          quantity
          units
          unitCost
          amount
          itemTax
          itemTotal
          serviceNote
          serviceDate
          createdAt
          updatedAt
        }
        nextToken
      }
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      trackCar {
        id
        active
        owner
        areaId
        zoneId
        aisleId
        trackId
        eodTrackId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        locationFullName
        reloadYardId
        accountId
        shipmentId
        parentType
        inbound {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outbound {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        railCarNumber
        sortKey
        eodSortKey
        movementLogs {
          trackCarId
          sortKey
          movedAt
          movedBy
        }
        updatedAt
        updatedBy
        createdAt
      }
      isCollected
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      containerDrop
      containerNumber
      customFields
      selectedCustomFields {
        id
        name
        type
        display
        required
      }
      timeslotId
      gateCheckInId
      timeslot {
        id
        owner
        groups
        status
        reloadYardId
        year
        month
        week
        day
        time
        startTime
        endTime
        inboundId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        accountName
        accountId
        eventTypeId
        eventType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          workflow
          reloadYardCommodityId
          createdAt
          updatedAt
        }
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        carrierUserId
        carrierUser {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      stepName
      sealNumbers
      seals {
        items {
          id
          active
          owner
          groups
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          isScanned
          createdAt
          createdBy
          validated
          reValidated
          brokenAt
          brokenBy
          description
          status
          updatedAt
        }
        nextToken
      }
      braData {
        id
        owner
        groups
        reloadYardId
        accountId
        braSessionId
        braRawData
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createInventorie = /* GraphQL */ `
  mutation CreateInventorie(
    $input: CreateInventoryInput!
    $condition: ModelInventoryConditionInput
  ) {
    createInventorie(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      lotNumber
      poNumber
      normalizedPoNumber
      railCarNumber
      normalizedRailCarNumber
      receivedAt
      depletedAt
      lastOutboundId
      turnDays
      quantityAdvised
      quantityReceived
      quantityPrecount
      quantityOnHand
      altQuantityOnHand
      quantityPhysical
      quantityCommitted
      altQuantityCommitted
      quantityMismatch
      inventoryUOM
      returnShipmentLineItemId
      pcs
      pcsHeight
      pcsWidth
      pcsLength
      pcsOnHand
      pcsCommitted
      weight
      weightUOM
      verificationRequired
      hasException
      overShipment
      overShipmentQuantity
      overShipmentNote
      underShipment
      underShipmentQuantity
      underShipmentNote
      isDamaged
      isRecalled
      recallNote
      otherException
      otherExceptionNote
      lotType
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      aisleList
      containerNumber
      outboundShipmentId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      photos {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          bucket
          region
          key
          type
          name
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      productName
      braRawProductName
      rawDataInventoryId
      productCode
      productId
      product {
        id
        owner
        groups
        active
        accountId
        reloadYardId
        name
        altNames
        productCode
        reloadYardCommodityId
        category
        defaultUOM
        defaultWeightUOM
        unit
        pcs
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        height
        width
        length
        pcsHeight
        pcsWidth
        pcsLength
        lowInventoryThreshold
        totalInventoryQuantity
        totalQuantityOnHand
        totalQuantityCommitted
        lowInventoryAlert
        customFields
        color
        status
        inventories {
          nextToken
        }
        velocityStats {
          id
          owner
          groups
          productId
          accountId
          reloadYardId
          stats
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      sortKey
      accountName
      accountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      inboundShipmentId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      shipmentLineItems {
        items {
          id
          owner
          groups
          active
          status
          sortKey
          lotNumber
          poNumber
          totalQuantityToPick
          totalQuantityReturned
          units
          outboundShipmentId
          accountId
          reloadYardId
          inventoryId
          createdAt
          updatedAt
        }
        nextToken
      }
      workOrderId
      workOrder {
        id
        owner
        groups
        active
        status
        state
        workType
        poNumber
        normalizedPoNumber
        totalUOM
        skipInvoice
        createDateTime
        startDateTime
        endDateTime
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        assignedTo
        workflowType
        processedBy
        verificationRequired
        hasException
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inputInventoryId
        inputInventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        workOrderItems {
          nextToken
        }
        outputInventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        stepName
        createdAt
        updatedAt
      }
      auditId
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      aggregateInventoryId
      inventoryItems {
        items {
          id
          owner
          groups
          quantityOnHand
          altQuantityOnHand
          quantityCommitted
          altQuantityCommitted
          pcsOnHand
          pcsCommitted
          hasException
          isDamaged
          originOfDamage
          otherException
          otherExceptionNote
          status
          accountId
          inboundShipmentId
          inventoryId
          barcode
          areaId
          zoneId
          aisleId
          locationId
          outboundShipmentId
          locationFullName
          latitude
          longitude
          reloadYardId
          unloadedAt
          unloadedBy
          depletedAt
          createdAt
          updatedAt
        }
        nextToken
      }
      customFields
      createdAt
      updatedAt
    }
  }
`;
export const updateInventorie = /* GraphQL */ `
  mutation UpdateInventorie(
    $input: UpdateInventoryInput!
    $condition: ModelInventoryConditionInput
  ) {
    updateInventorie(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      lotNumber
      poNumber
      normalizedPoNumber
      railCarNumber
      normalizedRailCarNumber
      receivedAt
      depletedAt
      lastOutboundId
      turnDays
      quantityAdvised
      quantityReceived
      quantityPrecount
      quantityOnHand
      altQuantityOnHand
      quantityPhysical
      quantityCommitted
      altQuantityCommitted
      quantityMismatch
      inventoryUOM
      returnShipmentLineItemId
      pcs
      pcsHeight
      pcsWidth
      pcsLength
      pcsOnHand
      pcsCommitted
      weight
      weightUOM
      verificationRequired
      hasException
      overShipment
      overShipmentQuantity
      overShipmentNote
      underShipment
      underShipmentQuantity
      underShipmentNote
      isDamaged
      isRecalled
      recallNote
      otherException
      otherExceptionNote
      lotType
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      aisleList
      containerNumber
      outboundShipmentId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      photos {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          bucket
          region
          key
          type
          name
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      productName
      braRawProductName
      rawDataInventoryId
      productCode
      productId
      product {
        id
        owner
        groups
        active
        accountId
        reloadYardId
        name
        altNames
        productCode
        reloadYardCommodityId
        category
        defaultUOM
        defaultWeightUOM
        unit
        pcs
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        height
        width
        length
        pcsHeight
        pcsWidth
        pcsLength
        lowInventoryThreshold
        totalInventoryQuantity
        totalQuantityOnHand
        totalQuantityCommitted
        lowInventoryAlert
        customFields
        color
        status
        inventories {
          nextToken
        }
        velocityStats {
          id
          owner
          groups
          productId
          accountId
          reloadYardId
          stats
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      sortKey
      accountName
      accountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      inboundShipmentId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      shipmentLineItems {
        items {
          id
          owner
          groups
          active
          status
          sortKey
          lotNumber
          poNumber
          totalQuantityToPick
          totalQuantityReturned
          units
          outboundShipmentId
          accountId
          reloadYardId
          inventoryId
          createdAt
          updatedAt
        }
        nextToken
      }
      workOrderId
      workOrder {
        id
        owner
        groups
        active
        status
        state
        workType
        poNumber
        normalizedPoNumber
        totalUOM
        skipInvoice
        createDateTime
        startDateTime
        endDateTime
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        assignedTo
        workflowType
        processedBy
        verificationRequired
        hasException
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inputInventoryId
        inputInventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        workOrderItems {
          nextToken
        }
        outputInventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        stepName
        createdAt
        updatedAt
      }
      auditId
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      aggregateInventoryId
      inventoryItems {
        items {
          id
          owner
          groups
          quantityOnHand
          altQuantityOnHand
          quantityCommitted
          altQuantityCommitted
          pcsOnHand
          pcsCommitted
          hasException
          isDamaged
          originOfDamage
          otherException
          otherExceptionNote
          status
          accountId
          inboundShipmentId
          inventoryId
          barcode
          areaId
          zoneId
          aisleId
          locationId
          outboundShipmentId
          locationFullName
          latitude
          longitude
          reloadYardId
          unloadedAt
          unloadedBy
          depletedAt
          createdAt
          updatedAt
        }
        nextToken
      }
      customFields
      createdAt
      updatedAt
    }
  }
`;
export const deleteInventorie = /* GraphQL */ `
  mutation DeleteInventorie(
    $input: DeleteInventoryInput!
    $condition: ModelInventoryConditionInput
  ) {
    deleteInventorie(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      lotNumber
      poNumber
      normalizedPoNumber
      railCarNumber
      normalizedRailCarNumber
      receivedAt
      depletedAt
      lastOutboundId
      turnDays
      quantityAdvised
      quantityReceived
      quantityPrecount
      quantityOnHand
      altQuantityOnHand
      quantityPhysical
      quantityCommitted
      altQuantityCommitted
      quantityMismatch
      inventoryUOM
      returnShipmentLineItemId
      pcs
      pcsHeight
      pcsWidth
      pcsLength
      pcsOnHand
      pcsCommitted
      weight
      weightUOM
      verificationRequired
      hasException
      overShipment
      overShipmentQuantity
      overShipmentNote
      underShipment
      underShipmentQuantity
      underShipmentNote
      isDamaged
      isRecalled
      recallNote
      otherException
      otherExceptionNote
      lotType
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      aisleList
      containerNumber
      outboundShipmentId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      photos {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          bucket
          region
          key
          type
          name
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      productName
      braRawProductName
      rawDataInventoryId
      productCode
      productId
      product {
        id
        owner
        groups
        active
        accountId
        reloadYardId
        name
        altNames
        productCode
        reloadYardCommodityId
        category
        defaultUOM
        defaultWeightUOM
        unit
        pcs
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        height
        width
        length
        pcsHeight
        pcsWidth
        pcsLength
        lowInventoryThreshold
        totalInventoryQuantity
        totalQuantityOnHand
        totalQuantityCommitted
        lowInventoryAlert
        customFields
        color
        status
        inventories {
          nextToken
        }
        velocityStats {
          id
          owner
          groups
          productId
          accountId
          reloadYardId
          stats
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      sortKey
      accountName
      accountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      inboundShipmentId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      shipmentLineItems {
        items {
          id
          owner
          groups
          active
          status
          sortKey
          lotNumber
          poNumber
          totalQuantityToPick
          totalQuantityReturned
          units
          outboundShipmentId
          accountId
          reloadYardId
          inventoryId
          createdAt
          updatedAt
        }
        nextToken
      }
      workOrderId
      workOrder {
        id
        owner
        groups
        active
        status
        state
        workType
        poNumber
        normalizedPoNumber
        totalUOM
        skipInvoice
        createDateTime
        startDateTime
        endDateTime
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        assignedTo
        workflowType
        processedBy
        verificationRequired
        hasException
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inputInventoryId
        inputInventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        workOrderItems {
          nextToken
        }
        outputInventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        stepName
        createdAt
        updatedAt
      }
      auditId
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      aggregateInventoryId
      inventoryItems {
        items {
          id
          owner
          groups
          quantityOnHand
          altQuantityOnHand
          quantityCommitted
          altQuantityCommitted
          pcsOnHand
          pcsCommitted
          hasException
          isDamaged
          originOfDamage
          otherException
          otherExceptionNote
          status
          accountId
          inboundShipmentId
          inventoryId
          barcode
          areaId
          zoneId
          aisleId
          locationId
          outboundShipmentId
          locationFullName
          latitude
          longitude
          reloadYardId
          unloadedAt
          unloadedBy
          depletedAt
          createdAt
          updatedAt
        }
        nextToken
      }
      customFields
      createdAt
      updatedAt
    }
  }
`;
export const createInventoryItem = /* GraphQL */ `
  mutation CreateInventoryItem(
    $input: CreateInventoryItemInput!
    $condition: ModelInventoryItemConditionInput
  ) {
    createInventoryItem(input: $input, condition: $condition) {
      id
      owner
      groups
      quantityOnHand
      altQuantityOnHand
      quantityCommitted
      altQuantityCommitted
      pcsOnHand
      pcsCommitted
      hasException
      isDamaged
      originOfDamage
      otherException
      otherExceptionNote
      status
      accountId
      inboundShipmentId
      inventoryId
      inventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      barcode
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      aisleId
      locationId
      location {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      outboundShipmentId
      locationFullName
      latitude
      longitude
      reloadYardId
      unloadedAt
      unloadedBy
      depletedAt
      seals {
        items {
          id
          active
          owner
          groups
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          isScanned
          createdAt
          createdBy
          validated
          reValidated
          brokenAt
          brokenBy
          description
          status
          updatedAt
        }
        nextToken
      }
      barcodes {
        items {
          id
          owner
          groups
          active
          status
          value
          isScanned
          scannedIn
          scannedOut
          reloadYardId
          inboundShipmentId
          inventoryId
          locationId
          inventoryItemId
          createdAt
          updatedAt
        }
        nextToken
      }
      history {
        type
        date
        by
        text
        public
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateInventoryItem = /* GraphQL */ `
  mutation UpdateInventoryItem(
    $input: UpdateInventoryItemInput!
    $condition: ModelInventoryItemConditionInput
  ) {
    updateInventoryItem(input: $input, condition: $condition) {
      id
      owner
      groups
      quantityOnHand
      altQuantityOnHand
      quantityCommitted
      altQuantityCommitted
      pcsOnHand
      pcsCommitted
      hasException
      isDamaged
      originOfDamage
      otherException
      otherExceptionNote
      status
      accountId
      inboundShipmentId
      inventoryId
      inventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      barcode
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      aisleId
      locationId
      location {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      outboundShipmentId
      locationFullName
      latitude
      longitude
      reloadYardId
      unloadedAt
      unloadedBy
      depletedAt
      seals {
        items {
          id
          active
          owner
          groups
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          isScanned
          createdAt
          createdBy
          validated
          reValidated
          brokenAt
          brokenBy
          description
          status
          updatedAt
        }
        nextToken
      }
      barcodes {
        items {
          id
          owner
          groups
          active
          status
          value
          isScanned
          scannedIn
          scannedOut
          reloadYardId
          inboundShipmentId
          inventoryId
          locationId
          inventoryItemId
          createdAt
          updatedAt
        }
        nextToken
      }
      history {
        type
        date
        by
        text
        public
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteInventoryItem = /* GraphQL */ `
  mutation DeleteInventoryItem(
    $input: DeleteInventoryItemInput!
    $condition: ModelInventoryItemConditionInput
  ) {
    deleteInventoryItem(input: $input, condition: $condition) {
      id
      owner
      groups
      quantityOnHand
      altQuantityOnHand
      quantityCommitted
      altQuantityCommitted
      pcsOnHand
      pcsCommitted
      hasException
      isDamaged
      originOfDamage
      otherException
      otherExceptionNote
      status
      accountId
      inboundShipmentId
      inventoryId
      inventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      barcode
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      aisleId
      locationId
      location {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      outboundShipmentId
      locationFullName
      latitude
      longitude
      reloadYardId
      unloadedAt
      unloadedBy
      depletedAt
      seals {
        items {
          id
          active
          owner
          groups
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          isScanned
          createdAt
          createdBy
          validated
          reValidated
          brokenAt
          brokenBy
          description
          status
          updatedAt
        }
        nextToken
      }
      barcodes {
        items {
          id
          owner
          groups
          active
          status
          value
          isScanned
          scannedIn
          scannedOut
          reloadYardId
          inboundShipmentId
          inventoryId
          locationId
          inventoryItemId
          createdAt
          updatedAt
        }
        nextToken
      }
      history {
        type
        date
        by
        text
        public
      }
      createdAt
      updatedAt
    }
  }
`;
export const createInvoice = /* GraphQL */ `
  mutation CreateInvoice(
    $input: CreateInvoiceInput!
    $condition: ModelInvoiceConditionInput
  ) {
    createInvoice(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      invoiceNumber
      externalId
      externalUrl
      externalStatus
      poNumber
      poNumbers
      railCarNumbers
      pickupNumbers
      event
      paymentTermId
      paymentTerm {
        id
        owner
        groups
        reloadYardId
        name
        code
        type
        dueDays
        dayOfMonthDue
        sortKey
        createdAt
        updatedAt
      }
      paymentTerms
      createDateTime
      dueDate
      overDue
      sentDate
      paidDate
      lineItems {
        items {
          id
          owner
          groups
          invoiceId
          serviceId
          event
          externalId
          sortKey
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          quantity
          units
          unitCost
          amount
          itemTax
          itemTotal
          serviceNote
          serviceDate
          createdAt
          updatedAt
        }
        nextToken
      }
      subtotal
      discount
      adjustment
      tax
      total
      balance
      payments {
        id
        amount
        paymentDate
        method
        reference
        memo
        recordedBy
        recordedAt
      }
      paymentReferences
      notes
      customFields
      accountName
      accountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      contact {
        name
        email
        phone
        description
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      reloadYardId
      reloadYard {
        id
        owner
        groups
        active
        status
        name
        phone
        fax
        email
        website
        street
        city
        state
        zipCode
        country
        latitude
        longitude
        geofence
        geofenceToleranceMeters
        geofenceEnabled
        geofenceEnforced
        driverCheckInEnabled
        driverIdentificationRequired
        driverIdScanRequired
        driverCheckInGraceMinutes
        driverCheckInWithoutAppointment
        driverInstructions
        postCheckInMessage
        driverStops {
          label
          message
        }
        driverIdImageRetention
        lotCapacity
        trackCapacity
        warehouseCapacity
        servingCarrier
        railHighway
        ast
        externalCompanyId
        taxRates {
          taxCode
          name
          taxRate
        }
        paymentTerms {
          nextToken
        }
        invoiceNumberPrefix
        invoiceCounter
        remittanceAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolCounter
        receiptCounter
        fileCategories {
          key
          name
        }
        mapImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        logoImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        areas {
          nextToken
        }
        zones {
          nextToken
        }
        aisles {
          nextToken
        }
        yardCommodities {
          nextToken
        }
        subscription {
          customerId
          subscriptionId
          priceId
          name
          status
        }
        tosAccept {
          acceptTimeStamp
          cognitoId
          email
          userAgent
          ip
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        timeZone
        railEquipmentTypes {
          nextToken
        }
        truckEquipmentTypes {
          nextToken
        }
        assetTypes {
          nextToken
        }
        eventTypes {
          nextToken
        }
        checklists {
          nextToken
        }
        apiKeys {
          nextToken
        }
        invoicesProcessedAt
        reportsProcessedAt
        createdAt
        updatedAt
      }
      inboundShipmentId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outboundShipmentId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateInvoice = /* GraphQL */ `
  mutation UpdateInvoice(
    $input: UpdateInvoiceInput!
    $condition: ModelInvoiceConditionInput
  ) {
    updateInvoice(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      invoiceNumber
      externalId
      externalUrl
      externalStatus
      poNumber
      poNumbers
      railCarNumbers
      pickupNumbers
      event
      paymentTermId
      paymentTerm {
        id
        owner
        groups
        reloadYardId
        name
        code
        type
        dueDays
        dayOfMonthDue
        sortKey
        createdAt
        updatedAt
      }
      paymentTerms
      createDateTime
      dueDate
      overDue
      sentDate
      paidDate
      lineItems {
        items {
          id
          owner
          groups
          invoiceId
          serviceId
          event
          externalId
          sortKey
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          quantity
          units
          unitCost
          amount
          itemTax
          itemTotal
          serviceNote
          serviceDate
          createdAt
          updatedAt
        }
        nextToken
      }
      subtotal
      discount
      adjustment
      tax
      total
      balance
      payments {
        id
        amount
        paymentDate
        method
        reference
        memo
        recordedBy
        recordedAt
      }
      paymentReferences
      notes
      customFields
      accountName
      accountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      contact {
        name
        email
        phone
        description
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      reloadYardId
      reloadYard {
        id
        owner
        groups
        active
        status
        name
        phone
        fax
        email
        website
        street
        city
        state
        zipCode
        country
        latitude
        longitude
        geofence
        geofenceToleranceMeters
        geofenceEnabled
        geofenceEnforced
        driverCheckInEnabled
        driverIdentificationRequired
        driverIdScanRequired
        driverCheckInGraceMinutes
        driverCheckInWithoutAppointment
        driverInstructions
        postCheckInMessage
        driverStops {
          label
          message
        }
        driverIdImageRetention
        lotCapacity
        trackCapacity
        warehouseCapacity
        servingCarrier
        railHighway
        ast
        externalCompanyId
        taxRates {
          taxCode
          name
          taxRate
        }
        paymentTerms {
          nextToken
        }
        invoiceNumberPrefix
        invoiceCounter
        remittanceAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolCounter
        receiptCounter
        fileCategories {
          key
          name
        }
        mapImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        logoImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        areas {
          nextToken
        }
        zones {
          nextToken
        }
        aisles {
          nextToken
        }
        yardCommodities {
          nextToken
        }
        subscription {
          customerId
          subscriptionId
          priceId
          name
          status
        }
        tosAccept {
          acceptTimeStamp
          cognitoId
          email
          userAgent
          ip
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        timeZone
        railEquipmentTypes {
          nextToken
        }
        truckEquipmentTypes {
          nextToken
        }
        assetTypes {
          nextToken
        }
        eventTypes {
          nextToken
        }
        checklists {
          nextToken
        }
        apiKeys {
          nextToken
        }
        invoicesProcessedAt
        reportsProcessedAt
        createdAt
        updatedAt
      }
      inboundShipmentId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outboundShipmentId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteInvoice = /* GraphQL */ `
  mutation DeleteInvoice(
    $input: DeleteInvoiceInput!
    $condition: ModelInvoiceConditionInput
  ) {
    deleteInvoice(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      invoiceNumber
      externalId
      externalUrl
      externalStatus
      poNumber
      poNumbers
      railCarNumbers
      pickupNumbers
      event
      paymentTermId
      paymentTerm {
        id
        owner
        groups
        reloadYardId
        name
        code
        type
        dueDays
        dayOfMonthDue
        sortKey
        createdAt
        updatedAt
      }
      paymentTerms
      createDateTime
      dueDate
      overDue
      sentDate
      paidDate
      lineItems {
        items {
          id
          owner
          groups
          invoiceId
          serviceId
          event
          externalId
          sortKey
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          quantity
          units
          unitCost
          amount
          itemTax
          itemTotal
          serviceNote
          serviceDate
          createdAt
          updatedAt
        }
        nextToken
      }
      subtotal
      discount
      adjustment
      tax
      total
      balance
      payments {
        id
        amount
        paymentDate
        method
        reference
        memo
        recordedBy
        recordedAt
      }
      paymentReferences
      notes
      customFields
      accountName
      accountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      contact {
        name
        email
        phone
        description
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      reloadYardId
      reloadYard {
        id
        owner
        groups
        active
        status
        name
        phone
        fax
        email
        website
        street
        city
        state
        zipCode
        country
        latitude
        longitude
        geofence
        geofenceToleranceMeters
        geofenceEnabled
        geofenceEnforced
        driverCheckInEnabled
        driverIdentificationRequired
        driverIdScanRequired
        driverCheckInGraceMinutes
        driverCheckInWithoutAppointment
        driverInstructions
        postCheckInMessage
        driverStops {
          label
          message
        }
        driverIdImageRetention
        lotCapacity
        trackCapacity
        warehouseCapacity
        servingCarrier
        railHighway
        ast
        externalCompanyId
        taxRates {
          taxCode
          name
          taxRate
        }
        paymentTerms {
          nextToken
        }
        invoiceNumberPrefix
        invoiceCounter
        remittanceAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolCounter
        receiptCounter
        fileCategories {
          key
          name
        }
        mapImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        logoImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        areas {
          nextToken
        }
        zones {
          nextToken
        }
        aisles {
          nextToken
        }
        yardCommodities {
          nextToken
        }
        subscription {
          customerId
          subscriptionId
          priceId
          name
          status
        }
        tosAccept {
          acceptTimeStamp
          cognitoId
          email
          userAgent
          ip
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        timeZone
        railEquipmentTypes {
          nextToken
        }
        truckEquipmentTypes {
          nextToken
        }
        assetTypes {
          nextToken
        }
        eventTypes {
          nextToken
        }
        checklists {
          nextToken
        }
        apiKeys {
          nextToken
        }
        invoicesProcessedAt
        reportsProcessedAt
        createdAt
        updatedAt
      }
      inboundShipmentId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outboundShipmentId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createInvoiceService = /* GraphQL */ `
  mutation CreateInvoiceService(
    $input: CreateInvoiceServiceInput!
    $condition: ModelInvoiceServiceConditionInput
  ) {
    createInvoiceService(input: $input, condition: $condition) {
      id
      owner
      groups
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      serviceId
      service {
        id
        owner
        groups
        active
        status
        reloadYardId
        accountName
        accountId
        name
        description
        taxRate {
          taxCode
          name
          taxRate
        }
        unit
        pcs
        car
        tl
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        createdAt
        updatedAt
      }
      event
      externalId
      sortKey
      accountId
      reloadYardId
      inboundShipmentId
      outboundShipmentId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      quantity
      units
      unitCost
      amount
      itemTax
      taxRate {
        taxCode
        name
        taxRate
      }
      itemTotal
      serviceNote
      serviceDate
      createdAt
      updatedAt
    }
  }
`;
export const updateInvoiceService = /* GraphQL */ `
  mutation UpdateInvoiceService(
    $input: UpdateInvoiceServiceInput!
    $condition: ModelInvoiceServiceConditionInput
  ) {
    updateInvoiceService(input: $input, condition: $condition) {
      id
      owner
      groups
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      serviceId
      service {
        id
        owner
        groups
        active
        status
        reloadYardId
        accountName
        accountId
        name
        description
        taxRate {
          taxCode
          name
          taxRate
        }
        unit
        pcs
        car
        tl
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        createdAt
        updatedAt
      }
      event
      externalId
      sortKey
      accountId
      reloadYardId
      inboundShipmentId
      outboundShipmentId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      quantity
      units
      unitCost
      amount
      itemTax
      taxRate {
        taxCode
        name
        taxRate
      }
      itemTotal
      serviceNote
      serviceDate
      createdAt
      updatedAt
    }
  }
`;
export const deleteInvoiceService = /* GraphQL */ `
  mutation DeleteInvoiceService(
    $input: DeleteInvoiceServiceInput!
    $condition: ModelInvoiceServiceConditionInput
  ) {
    deleteInvoiceService(input: $input, condition: $condition) {
      id
      owner
      groups
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      serviceId
      service {
        id
        owner
        groups
        active
        status
        reloadYardId
        accountName
        accountId
        name
        description
        taxRate {
          taxCode
          name
          taxRate
        }
        unit
        pcs
        car
        tl
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        createdAt
        updatedAt
      }
      event
      externalId
      sortKey
      accountId
      reloadYardId
      inboundShipmentId
      outboundShipmentId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      quantity
      units
      unitCost
      amount
      itemTax
      taxRate {
        taxCode
        name
        taxRate
      }
      itemTotal
      serviceNote
      serviceDate
      createdAt
      updatedAt
    }
  }
`;
export const createLocation = /* GraphQL */ `
  mutation CreateLocation(
    $input: CreateLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    createLocation(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      reloadYardId
      accountName
      name
      type
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      aisleId
      aisle {
        id
        owner
        groups
        active
        reloadYardId
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        locations {
          nextToken
        }
        bays
        levels
        positions
        totalLocations
        capacityUsed
        length
        width
        sortKey
        topDownPickOrder
        createdAt
        updatedAt
      }
      bay
      level
      position
      capacityAllocated
      capacityUsed
      length
      width
      sortKey
      locationLoad {
        other {
          selected
          capacity
        }
        pallet {
          selected
          capacity
        }
        box {
          selected
          capacity
        }
        superSack {
          selected
          capacity
        }
        container {
          selected
          capacity
        }
        dryBulk {
          selected
          capacity
        }
        liquidBulk {
          selected
          capacity
        }
      }
      productId
      productName
      bulkCapacity
      bulkUnits
      isContaminated
      containerNumber
      tags {
        items {
          id
          owner
          groups
          reloadYardId
          locationId
          tagId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateLocation = /* GraphQL */ `
  mutation UpdateLocation(
    $input: UpdateLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    updateLocation(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      reloadYardId
      accountName
      name
      type
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      aisleId
      aisle {
        id
        owner
        groups
        active
        reloadYardId
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        locations {
          nextToken
        }
        bays
        levels
        positions
        totalLocations
        capacityUsed
        length
        width
        sortKey
        topDownPickOrder
        createdAt
        updatedAt
      }
      bay
      level
      position
      capacityAllocated
      capacityUsed
      length
      width
      sortKey
      locationLoad {
        other {
          selected
          capacity
        }
        pallet {
          selected
          capacity
        }
        box {
          selected
          capacity
        }
        superSack {
          selected
          capacity
        }
        container {
          selected
          capacity
        }
        dryBulk {
          selected
          capacity
        }
        liquidBulk {
          selected
          capacity
        }
      }
      productId
      productName
      bulkCapacity
      bulkUnits
      isContaminated
      containerNumber
      tags {
        items {
          id
          owner
          groups
          reloadYardId
          locationId
          tagId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteLocation = /* GraphQL */ `
  mutation DeleteLocation(
    $input: DeleteLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    deleteLocation(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      reloadYardId
      accountName
      name
      type
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      aisleId
      aisle {
        id
        owner
        groups
        active
        reloadYardId
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        locations {
          nextToken
        }
        bays
        levels
        positions
        totalLocations
        capacityUsed
        length
        width
        sortKey
        topDownPickOrder
        createdAt
        updatedAt
      }
      bay
      level
      position
      capacityAllocated
      capacityUsed
      length
      width
      sortKey
      locationLoad {
        other {
          selected
          capacity
        }
        pallet {
          selected
          capacity
        }
        box {
          selected
          capacity
        }
        superSack {
          selected
          capacity
        }
        container {
          selected
          capacity
        }
        dryBulk {
          selected
          capacity
        }
        liquidBulk {
          selected
          capacity
        }
      }
      productId
      productName
      bulkCapacity
      bulkUnits
      isContaminated
      containerNumber
      tags {
        items {
          id
          owner
          groups
          reloadYardId
          locationId
          tagId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createLocationTag = /* GraphQL */ `
  mutation CreateLocationTag(
    $input: CreateLocationTagInput!
    $condition: ModelLocationTagConditionInput
  ) {
    createLocationTag(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      locationId
      location {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      tagId
      tag {
        id
        owner
        groups
        reloadYardId
        name
        description
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateLocationTag = /* GraphQL */ `
  mutation UpdateLocationTag(
    $input: UpdateLocationTagInput!
    $condition: ModelLocationTagConditionInput
  ) {
    updateLocationTag(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      locationId
      location {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      tagId
      tag {
        id
        owner
        groups
        reloadYardId
        name
        description
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteLocationTag = /* GraphQL */ `
  mutation DeleteLocationTag(
    $input: DeleteLocationTagInput!
    $condition: ModelLocationTagConditionInput
  ) {
    deleteLocationTag(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      locationId
      location {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      tagId
      tag {
        id
        owner
        groups
        reloadYardId
        name
        description
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createLog = /* GraphQL */ `
  mutation CreateLog(
    $input: CreateLogInput!
    $condition: ModelLogConditionInput
  ) {
    createLog(input: $input, condition: $condition) {
      id
      status
      createdAt
      appType
      tenantId
      user
      message
      exception
      appVersion
      url
      context
      owner
      updatedAt
    }
  }
`;
export const updateLog = /* GraphQL */ `
  mutation UpdateLog(
    $input: UpdateLogInput!
    $condition: ModelLogConditionInput
  ) {
    updateLog(input: $input, condition: $condition) {
      id
      status
      createdAt
      appType
      tenantId
      user
      message
      exception
      appVersion
      url
      context
      owner
      updatedAt
    }
  }
`;
export const deleteLog = /* GraphQL */ `
  mutation DeleteLog(
    $input: DeleteLogInput!
    $condition: ModelLogConditionInput
  ) {
    deleteLog(input: $input, condition: $condition) {
      id
      status
      createdAt
      appType
      tenantId
      user
      message
      exception
      appVersion
      url
      context
      owner
      updatedAt
    }
  }
`;
export const createOutboundShipment = /* GraphQL */ `
  mutation CreateOutboundShipment(
    $input: CreateOutboundShipmentInput!
    $condition: ModelOutboundShipmentConditionInput
  ) {
    createOutboundShipment(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      state
      transfer
      transferToAccountId
      transferToAccountName
      poNumber
      pickupNumber
      consigneePoNumber
      normalizedPoNumber
      normalizedPickupNumber
      normalizedConsigneePoNumber
      shipTo {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      carrierType
      carrier
      carrierName
      carrierId
      driverId
      driver {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      driverName
      bolNumber
      railCarNumber
      normalizedRailCarNumber
      carrierEquipmentTypeId
      railEquipmentType {
        id
        owner
        groups
        active
        name
        arrTypeCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      truckEquipmentType {
        id
        owner
        groups
        active
        name
        dotSpecCode
        dotClassCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      mustTarp
      didTarp
      containerPickup
      skipSignature
      yardSignatureKey
      carrierSignatureKey
      signedBy
      createDateTime
      scheduledDateTime
      arrivalDateTime
      placementDateTime
      startDateTime
      endDateTime
      departureDateTime
      collectedDateTime
      deliveryDateTime
      daysOnDemurrageClock
      tareWeight
      ladenWeight
      weightUnits
      netWeight
      scaleWeightUnits
      totalUOM
      skipInvoice
      photos {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          bucket
          region
          key
          type
          name
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      bolFile {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      sealNumber
      assignedTo
      instructions
      checklist {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      trackCar {
        id
        active
        owner
        areaId
        zoneId
        aisleId
        trackId
        eodTrackId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        locationFullName
        reloadYardId
        accountId
        shipmentId
        parentType
        inbound {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outbound {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        railCarNumber
        sortKey
        eodSortKey
        movementLogs {
          trackCarId
          sortKey
          movedAt
          movedBy
        }
        updatedAt
        updatedBy
        createdAt
      }
      isCollected
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      accountName
      accountId
      billToAccountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      billToAccount {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      shipmentLineItems {
        items {
          id
          owner
          groups
          active
          status
          sortKey
          lotNumber
          poNumber
          totalQuantityToPick
          totalQuantityReturned
          units
          outboundShipmentId
          accountId
          reloadYardId
          inventoryId
          createdAt
          updatedAt
        }
        nextToken
      }
      manualCharges {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          chargeRuleId
          quantity
          sortKey
          invoiceServiceId
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      invoicedServices {
        items {
          id
          owner
          groups
          invoiceId
          serviceId
          event
          externalId
          sortKey
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          quantity
          units
          unitCost
          amount
          itemTax
          itemTotal
          serviceNote
          serviceDate
          createdAt
          updatedAt
        }
        nextToken
      }
      customFields
      selectedCustomFields {
        id
        name
        type
        display
        required
      }
      timeslotId
      gateCheckInId
      shipWithGroupId
      shipWithIds
      timeslot {
        id
        owner
        groups
        status
        reloadYardId
        year
        month
        week
        day
        time
        startTime
        endTime
        inboundId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        accountName
        accountId
        eventTypeId
        eventType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          workflow
          reloadYardCommodityId
          createdAt
          updatedAt
        }
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        carrierUserId
        carrierUser {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      advisedBy
      inspectedBy
      stepName
      seals {
        items {
          id
          active
          owner
          groups
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          isScanned
          createdAt
          createdBy
          validated
          reValidated
          brokenAt
          brokenBy
          description
          status
          updatedAt
        }
        nextToken
      }
      hasException
      returnShipment
      returnReason
      createdAt
      updatedAt
    }
  }
`;
export const updateOutboundShipment = /* GraphQL */ `
  mutation UpdateOutboundShipment(
    $input: UpdateOutboundShipmentInput!
    $condition: ModelOutboundShipmentConditionInput
  ) {
    updateOutboundShipment(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      state
      transfer
      transferToAccountId
      transferToAccountName
      poNumber
      pickupNumber
      consigneePoNumber
      normalizedPoNumber
      normalizedPickupNumber
      normalizedConsigneePoNumber
      shipTo {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      carrierType
      carrier
      carrierName
      carrierId
      driverId
      driver {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      driverName
      bolNumber
      railCarNumber
      normalizedRailCarNumber
      carrierEquipmentTypeId
      railEquipmentType {
        id
        owner
        groups
        active
        name
        arrTypeCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      truckEquipmentType {
        id
        owner
        groups
        active
        name
        dotSpecCode
        dotClassCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      mustTarp
      didTarp
      containerPickup
      skipSignature
      yardSignatureKey
      carrierSignatureKey
      signedBy
      createDateTime
      scheduledDateTime
      arrivalDateTime
      placementDateTime
      startDateTime
      endDateTime
      departureDateTime
      collectedDateTime
      deliveryDateTime
      daysOnDemurrageClock
      tareWeight
      ladenWeight
      weightUnits
      netWeight
      scaleWeightUnits
      totalUOM
      skipInvoice
      photos {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          bucket
          region
          key
          type
          name
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      bolFile {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      sealNumber
      assignedTo
      instructions
      checklist {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      trackCar {
        id
        active
        owner
        areaId
        zoneId
        aisleId
        trackId
        eodTrackId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        locationFullName
        reloadYardId
        accountId
        shipmentId
        parentType
        inbound {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outbound {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        railCarNumber
        sortKey
        eodSortKey
        movementLogs {
          trackCarId
          sortKey
          movedAt
          movedBy
        }
        updatedAt
        updatedBy
        createdAt
      }
      isCollected
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      accountName
      accountId
      billToAccountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      billToAccount {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      shipmentLineItems {
        items {
          id
          owner
          groups
          active
          status
          sortKey
          lotNumber
          poNumber
          totalQuantityToPick
          totalQuantityReturned
          units
          outboundShipmentId
          accountId
          reloadYardId
          inventoryId
          createdAt
          updatedAt
        }
        nextToken
      }
      manualCharges {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          chargeRuleId
          quantity
          sortKey
          invoiceServiceId
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      invoicedServices {
        items {
          id
          owner
          groups
          invoiceId
          serviceId
          event
          externalId
          sortKey
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          quantity
          units
          unitCost
          amount
          itemTax
          itemTotal
          serviceNote
          serviceDate
          createdAt
          updatedAt
        }
        nextToken
      }
      customFields
      selectedCustomFields {
        id
        name
        type
        display
        required
      }
      timeslotId
      gateCheckInId
      shipWithGroupId
      shipWithIds
      timeslot {
        id
        owner
        groups
        status
        reloadYardId
        year
        month
        week
        day
        time
        startTime
        endTime
        inboundId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        accountName
        accountId
        eventTypeId
        eventType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          workflow
          reloadYardCommodityId
          createdAt
          updatedAt
        }
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        carrierUserId
        carrierUser {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      advisedBy
      inspectedBy
      stepName
      seals {
        items {
          id
          active
          owner
          groups
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          isScanned
          createdAt
          createdBy
          validated
          reValidated
          brokenAt
          brokenBy
          description
          status
          updatedAt
        }
        nextToken
      }
      hasException
      returnShipment
      returnReason
      createdAt
      updatedAt
    }
  }
`;
export const deleteOutboundShipment = /* GraphQL */ `
  mutation DeleteOutboundShipment(
    $input: DeleteOutboundShipmentInput!
    $condition: ModelOutboundShipmentConditionInput
  ) {
    deleteOutboundShipment(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      state
      transfer
      transferToAccountId
      transferToAccountName
      poNumber
      pickupNumber
      consigneePoNumber
      normalizedPoNumber
      normalizedPickupNumber
      normalizedConsigneePoNumber
      shipTo {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      carrierType
      carrier
      carrierName
      carrierId
      driverId
      driver {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      driverName
      bolNumber
      railCarNumber
      normalizedRailCarNumber
      carrierEquipmentTypeId
      railEquipmentType {
        id
        owner
        groups
        active
        name
        arrTypeCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      truckEquipmentType {
        id
        owner
        groups
        active
        name
        dotSpecCode
        dotClassCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      mustTarp
      didTarp
      containerPickup
      skipSignature
      yardSignatureKey
      carrierSignatureKey
      signedBy
      createDateTime
      scheduledDateTime
      arrivalDateTime
      placementDateTime
      startDateTime
      endDateTime
      departureDateTime
      collectedDateTime
      deliveryDateTime
      daysOnDemurrageClock
      tareWeight
      ladenWeight
      weightUnits
      netWeight
      scaleWeightUnits
      totalUOM
      skipInvoice
      photos {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          bucket
          region
          key
          type
          name
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      bolFile {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      sealNumber
      assignedTo
      instructions
      checklist {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      trackCar {
        id
        active
        owner
        areaId
        zoneId
        aisleId
        trackId
        eodTrackId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        locationFullName
        reloadYardId
        accountId
        shipmentId
        parentType
        inbound {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outbound {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        railCarNumber
        sortKey
        eodSortKey
        movementLogs {
          trackCarId
          sortKey
          movedAt
          movedBy
        }
        updatedAt
        updatedBy
        createdAt
      }
      isCollected
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      accountName
      accountId
      billToAccountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      billToAccount {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      shipmentLineItems {
        items {
          id
          owner
          groups
          active
          status
          sortKey
          lotNumber
          poNumber
          totalQuantityToPick
          totalQuantityReturned
          units
          outboundShipmentId
          accountId
          reloadYardId
          inventoryId
          createdAt
          updatedAt
        }
        nextToken
      }
      manualCharges {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          chargeRuleId
          quantity
          sortKey
          invoiceServiceId
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      invoicedServices {
        items {
          id
          owner
          groups
          invoiceId
          serviceId
          event
          externalId
          sortKey
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          quantity
          units
          unitCost
          amount
          itemTax
          itemTotal
          serviceNote
          serviceDate
          createdAt
          updatedAt
        }
        nextToken
      }
      customFields
      selectedCustomFields {
        id
        name
        type
        display
        required
      }
      timeslotId
      gateCheckInId
      shipWithGroupId
      shipWithIds
      timeslot {
        id
        owner
        groups
        status
        reloadYardId
        year
        month
        week
        day
        time
        startTime
        endTime
        inboundId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        accountName
        accountId
        eventTypeId
        eventType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          workflow
          reloadYardCommodityId
          createdAt
          updatedAt
        }
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        carrierUserId
        carrierUser {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      advisedBy
      inspectedBy
      stepName
      seals {
        items {
          id
          active
          owner
          groups
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          isScanned
          createdAt
          createdBy
          validated
          reValidated
          brokenAt
          brokenBy
          description
          status
          updatedAt
        }
        nextToken
      }
      hasException
      returnShipment
      returnReason
      createdAt
      updatedAt
    }
  }
`;
export const createPaymentTerm = /* GraphQL */ `
  mutation CreatePaymentTerm(
    $input: CreatePaymentTermInput!
    $condition: ModelPaymentTermConditionInput
  ) {
    createPaymentTerm(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      name
      code
      type
      dueDays
      dayOfMonthDue
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const updatePaymentTerm = /* GraphQL */ `
  mutation UpdatePaymentTerm(
    $input: UpdatePaymentTermInput!
    $condition: ModelPaymentTermConditionInput
  ) {
    updatePaymentTerm(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      name
      code
      type
      dueDays
      dayOfMonthDue
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const deletePaymentTerm = /* GraphQL */ `
  mutation DeletePaymentTerm(
    $input: DeletePaymentTermInput!
    $condition: ModelPaymentTermConditionInput
  ) {
    deletePaymentTerm(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      name
      code
      type
      dueDays
      dayOfMonthDue
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const createPhoto = /* GraphQL */ `
  mutation CreatePhoto(
    $input: CreatePhotoInput!
    $condition: ModelPhotoConditionInput
  ) {
    createPhoto(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      parentId
      parentType
      bucket
      region
      key
      type
      name
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const updatePhoto = /* GraphQL */ `
  mutation UpdatePhoto(
    $input: UpdatePhotoInput!
    $condition: ModelPhotoConditionInput
  ) {
    updatePhoto(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      parentId
      parentType
      bucket
      region
      key
      type
      name
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const deletePhoto = /* GraphQL */ `
  mutation DeletePhoto(
    $input: DeletePhotoInput!
    $condition: ModelPhotoConditionInput
  ) {
    deletePhoto(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      parentId
      parentType
      bucket
      region
      key
      type
      name
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const createProduct = /* GraphQL */ `
  mutation CreateProduct(
    $input: CreateProductInput!
    $condition: ModelProductConditionInput
  ) {
    createProduct(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      accountId
      reloadYardId
      name
      altNames
      productCode
      reloadYardCommodityId
      category
      defaultUOM
      defaultWeightUOM
      unit
      pcs
      mbf
      lf
      sf
      msf
      sqm
      gal
      l
      lbs
      tn
      cwt
      kg
      mt
      ft
      m
      height
      width
      length
      pcsHeight
      pcsWidth
      pcsLength
      lowInventoryThreshold
      totalInventoryQuantity
      totalQuantityOnHand
      totalQuantityCommitted
      lowInventoryAlert
      customFields
      color
      status
      inventories {
        items {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        nextToken
      }
      velocityStats {
        id
        owner
        groups
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        accountId
        reloadYardId
        stats
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateProduct = /* GraphQL */ `
  mutation UpdateProduct(
    $input: UpdateProductInput!
    $condition: ModelProductConditionInput
  ) {
    updateProduct(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      accountId
      reloadYardId
      name
      altNames
      productCode
      reloadYardCommodityId
      category
      defaultUOM
      defaultWeightUOM
      unit
      pcs
      mbf
      lf
      sf
      msf
      sqm
      gal
      l
      lbs
      tn
      cwt
      kg
      mt
      ft
      m
      height
      width
      length
      pcsHeight
      pcsWidth
      pcsLength
      lowInventoryThreshold
      totalInventoryQuantity
      totalQuantityOnHand
      totalQuantityCommitted
      lowInventoryAlert
      customFields
      color
      status
      inventories {
        items {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        nextToken
      }
      velocityStats {
        id
        owner
        groups
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        accountId
        reloadYardId
        stats
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteProduct = /* GraphQL */ `
  mutation DeleteProduct(
    $input: DeleteProductInput!
    $condition: ModelProductConditionInput
  ) {
    deleteProduct(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      accountId
      reloadYardId
      name
      altNames
      productCode
      reloadYardCommodityId
      category
      defaultUOM
      defaultWeightUOM
      unit
      pcs
      mbf
      lf
      sf
      msf
      sqm
      gal
      l
      lbs
      tn
      cwt
      kg
      mt
      ft
      m
      height
      width
      length
      pcsHeight
      pcsWidth
      pcsLength
      lowInventoryThreshold
      totalInventoryQuantity
      totalQuantityOnHand
      totalQuantityCommitted
      lowInventoryAlert
      customFields
      color
      status
      inventories {
        items {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        nextToken
      }
      velocityStats {
        id
        owner
        groups
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        accountId
        reloadYardId
        stats
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createProductStats = /* GraphQL */ `
  mutation CreateProductStats(
    $input: CreateProductStatsInput!
    $condition: ModelProductStatsConditionInput
  ) {
    createProductStats(input: $input, condition: $condition) {
      id
      owner
      groups
      productId
      product {
        id
        owner
        groups
        active
        accountId
        reloadYardId
        name
        altNames
        productCode
        reloadYardCommodityId
        category
        defaultUOM
        defaultWeightUOM
        unit
        pcs
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        height
        width
        length
        pcsHeight
        pcsWidth
        pcsLength
        lowInventoryThreshold
        totalInventoryQuantity
        totalQuantityOnHand
        totalQuantityCommitted
        lowInventoryAlert
        customFields
        color
        status
        inventories {
          nextToken
        }
        velocityStats {
          id
          owner
          groups
          productId
          accountId
          reloadYardId
          stats
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      accountId
      reloadYardId
      stats
      createdAt
      updatedAt
    }
  }
`;
export const updateProductStats = /* GraphQL */ `
  mutation UpdateProductStats(
    $input: UpdateProductStatsInput!
    $condition: ModelProductStatsConditionInput
  ) {
    updateProductStats(input: $input, condition: $condition) {
      id
      owner
      groups
      productId
      product {
        id
        owner
        groups
        active
        accountId
        reloadYardId
        name
        altNames
        productCode
        reloadYardCommodityId
        category
        defaultUOM
        defaultWeightUOM
        unit
        pcs
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        height
        width
        length
        pcsHeight
        pcsWidth
        pcsLength
        lowInventoryThreshold
        totalInventoryQuantity
        totalQuantityOnHand
        totalQuantityCommitted
        lowInventoryAlert
        customFields
        color
        status
        inventories {
          nextToken
        }
        velocityStats {
          id
          owner
          groups
          productId
          accountId
          reloadYardId
          stats
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      accountId
      reloadYardId
      stats
      createdAt
      updatedAt
    }
  }
`;
export const deleteProductStats = /* GraphQL */ `
  mutation DeleteProductStats(
    $input: DeleteProductStatsInput!
    $condition: ModelProductStatsConditionInput
  ) {
    deleteProductStats(input: $input, condition: $condition) {
      id
      owner
      groups
      productId
      product {
        id
        owner
        groups
        active
        accountId
        reloadYardId
        name
        altNames
        productCode
        reloadYardCommodityId
        category
        defaultUOM
        defaultWeightUOM
        unit
        pcs
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        height
        width
        length
        pcsHeight
        pcsWidth
        pcsLength
        lowInventoryThreshold
        totalInventoryQuantity
        totalQuantityOnHand
        totalQuantityCommitted
        lowInventoryAlert
        customFields
        color
        status
        inventories {
          nextToken
        }
        velocityStats {
          id
          owner
          groups
          productId
          accountId
          reloadYardId
          stats
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      accountId
      reloadYardId
      stats
      createdAt
      updatedAt
    }
  }
`;
export const createRailEquipmentType = /* GraphQL */ `
  mutation CreateRailEquipmentType(
    $input: CreateRailEquipmentTypeInput!
    $condition: ModelRailEquipmentTypeConditionInput
  ) {
    createRailEquipmentType(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      name
      arrTypeCode
      length
      reloadYardId
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const updateRailEquipmentType = /* GraphQL */ `
  mutation UpdateRailEquipmentType(
    $input: UpdateRailEquipmentTypeInput!
    $condition: ModelRailEquipmentTypeConditionInput
  ) {
    updateRailEquipmentType(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      name
      arrTypeCode
      length
      reloadYardId
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const deleteRailEquipmentType = /* GraphQL */ `
  mutation DeleteRailEquipmentType(
    $input: DeleteRailEquipmentTypeInput!
    $condition: ModelRailEquipmentTypeConditionInput
  ) {
    deleteRailEquipmentType(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      name
      arrTypeCode
      length
      reloadYardId
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const createRawData = /* GraphQL */ `
  mutation CreateRawData(
    $input: CreateRawDataInput!
    $condition: ModelRawDataConditionInput
  ) {
    createRawData(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      accountId
      braSessionId
      braRawData
      createdAt
      updatedAt
    }
  }
`;
export const updateRawData = /* GraphQL */ `
  mutation UpdateRawData(
    $input: UpdateRawDataInput!
    $condition: ModelRawDataConditionInput
  ) {
    updateRawData(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      accountId
      braSessionId
      braRawData
      createdAt
      updatedAt
    }
  }
`;
export const deleteRawData = /* GraphQL */ `
  mutation DeleteRawData(
    $input: DeleteRawDataInput!
    $condition: ModelRawDataConditionInput
  ) {
    deleteRawData(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      accountId
      braSessionId
      braRawData
      createdAt
      updatedAt
    }
  }
`;
export const createReloadYard = /* GraphQL */ `
  mutation CreateReloadYard(
    $input: CreateReloadYardInput!
    $condition: ModelReloadYardConditionInput
  ) {
    createReloadYard(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      name
      phone
      fax
      email
      website
      street
      city
      state
      zipCode
      country
      latitude
      longitude
      geofence
      geofenceToleranceMeters
      geofenceEnabled
      geofenceEnforced
      driverCheckInEnabled
      driverIdentificationRequired
      driverIdScanRequired
      driverCheckInGraceMinutes
      driverCheckInWithoutAppointment
      driverInstructions
      postCheckInMessage
      driverStops {
        label
        message
      }
      driverIdImageRetention
      lotCapacity
      trackCapacity
      warehouseCapacity
      servingCarrier
      railHighway
      ast
      externalCompanyId
      taxRates {
        taxCode
        name
        taxRate
      }
      paymentTerms {
        items {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceNumberPrefix
      invoiceCounter
      remittanceAddress {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      bolTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      bolCounter
      receiptCounter
      fileCategories {
        key
        name
      }
      mapImage {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      logoImage {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      areas {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      zones {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      aisles {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        nextToken
      }
      yardCommodities {
        items {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      subscription {
        customerId
        subscriptionId
        priceId
        name
        status
      }
      tosAccept {
        acceptTimeStamp
        cognitoId
        email
        userAgent
        ip
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      notes {
        type
        date
        by
        text
        public
      }
      schedule {
        workdays {
          id
          name
          startDayTime
          endDayTime
          selected
        }
        holidays
        minNoticeHours
        maxDaysIntoFuture
        layout
      }
      timeZone
      railEquipmentTypes {
        items {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      truckEquipmentTypes {
        items {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      assetTypes {
        items {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          maxConcurrentBookings
          createdAt
          updatedAt
        }
        nextToken
      }
      eventTypes {
        items {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          workflow
          reloadYardCommodityId
          createdAt
          updatedAt
        }
        nextToken
      }
      checklists {
        items {
          id
          owner
          groups
          active
          reloadYardId
          resourceId
          name
          description
          processName
          reloadYardCommodityId
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      apiKeys {
        items {
          id
          active
          groups
          reloadYardId
          name
          keyId
          createdBy
          deletedBy
          createdAt
          updatedAt
        }
        nextToken
      }
      invoicesProcessedAt
      reportsProcessedAt
      createdAt
      updatedAt
    }
  }
`;
export const updateReloadYard = /* GraphQL */ `
  mutation UpdateReloadYard(
    $input: UpdateReloadYardInput!
    $condition: ModelReloadYardConditionInput
  ) {
    updateReloadYard(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      name
      phone
      fax
      email
      website
      street
      city
      state
      zipCode
      country
      latitude
      longitude
      geofence
      geofenceToleranceMeters
      geofenceEnabled
      geofenceEnforced
      driverCheckInEnabled
      driverIdentificationRequired
      driverIdScanRequired
      driverCheckInGraceMinutes
      driverCheckInWithoutAppointment
      driverInstructions
      postCheckInMessage
      driverStops {
        label
        message
      }
      driverIdImageRetention
      lotCapacity
      trackCapacity
      warehouseCapacity
      servingCarrier
      railHighway
      ast
      externalCompanyId
      taxRates {
        taxCode
        name
        taxRate
      }
      paymentTerms {
        items {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceNumberPrefix
      invoiceCounter
      remittanceAddress {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      bolTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      bolCounter
      receiptCounter
      fileCategories {
        key
        name
      }
      mapImage {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      logoImage {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      areas {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      zones {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      aisles {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        nextToken
      }
      yardCommodities {
        items {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      subscription {
        customerId
        subscriptionId
        priceId
        name
        status
      }
      tosAccept {
        acceptTimeStamp
        cognitoId
        email
        userAgent
        ip
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      notes {
        type
        date
        by
        text
        public
      }
      schedule {
        workdays {
          id
          name
          startDayTime
          endDayTime
          selected
        }
        holidays
        minNoticeHours
        maxDaysIntoFuture
        layout
      }
      timeZone
      railEquipmentTypes {
        items {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      truckEquipmentTypes {
        items {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      assetTypes {
        items {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          maxConcurrentBookings
          createdAt
          updatedAt
        }
        nextToken
      }
      eventTypes {
        items {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          workflow
          reloadYardCommodityId
          createdAt
          updatedAt
        }
        nextToken
      }
      checklists {
        items {
          id
          owner
          groups
          active
          reloadYardId
          resourceId
          name
          description
          processName
          reloadYardCommodityId
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      apiKeys {
        items {
          id
          active
          groups
          reloadYardId
          name
          keyId
          createdBy
          deletedBy
          createdAt
          updatedAt
        }
        nextToken
      }
      invoicesProcessedAt
      reportsProcessedAt
      createdAt
      updatedAt
    }
  }
`;
export const deleteReloadYard = /* GraphQL */ `
  mutation DeleteReloadYard(
    $input: DeleteReloadYardInput!
    $condition: ModelReloadYardConditionInput
  ) {
    deleteReloadYard(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      name
      phone
      fax
      email
      website
      street
      city
      state
      zipCode
      country
      latitude
      longitude
      geofence
      geofenceToleranceMeters
      geofenceEnabled
      geofenceEnforced
      driverCheckInEnabled
      driverIdentificationRequired
      driverIdScanRequired
      driverCheckInGraceMinutes
      driverCheckInWithoutAppointment
      driverInstructions
      postCheckInMessage
      driverStops {
        label
        message
      }
      driverIdImageRetention
      lotCapacity
      trackCapacity
      warehouseCapacity
      servingCarrier
      railHighway
      ast
      externalCompanyId
      taxRates {
        taxCode
        name
        taxRate
      }
      paymentTerms {
        items {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceNumberPrefix
      invoiceCounter
      remittanceAddress {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      bolTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      bolCounter
      receiptCounter
      fileCategories {
        key
        name
      }
      mapImage {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      logoImage {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      areas {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      zones {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      aisles {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        nextToken
      }
      yardCommodities {
        items {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      subscription {
        customerId
        subscriptionId
        priceId
        name
        status
      }
      tosAccept {
        acceptTimeStamp
        cognitoId
        email
        userAgent
        ip
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      notes {
        type
        date
        by
        text
        public
      }
      schedule {
        workdays {
          id
          name
          startDayTime
          endDayTime
          selected
        }
        holidays
        minNoticeHours
        maxDaysIntoFuture
        layout
      }
      timeZone
      railEquipmentTypes {
        items {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      truckEquipmentTypes {
        items {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      assetTypes {
        items {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          maxConcurrentBookings
          createdAt
          updatedAt
        }
        nextToken
      }
      eventTypes {
        items {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          workflow
          reloadYardCommodityId
          createdAt
          updatedAt
        }
        nextToken
      }
      checklists {
        items {
          id
          owner
          groups
          active
          reloadYardId
          resourceId
          name
          description
          processName
          reloadYardCommodityId
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      apiKeys {
        items {
          id
          active
          groups
          reloadYardId
          name
          keyId
          createdBy
          deletedBy
          createdAt
          updatedAt
        }
        nextToken
      }
      invoicesProcessedAt
      reportsProcessedAt
      createdAt
      updatedAt
    }
  }
`;
export const createReloadYardCapability = /* GraphQL */ `
  mutation CreateReloadYardCapability(
    $input: CreateReloadYardCapabilityInput!
    $condition: ModelReloadYardCapabilityConditionInput
  ) {
    createReloadYardCapability(input: $input, condition: $condition) {
      id
      reloadYardId
      capabilityId
      owner
      groups
      active
      verified
      requiredValue
      capability {
        id
        active
        sortKey
        name
        description
        requiresValue
        requiredValueLabel
        quantity
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateReloadYardCapability = /* GraphQL */ `
  mutation UpdateReloadYardCapability(
    $input: UpdateReloadYardCapabilityInput!
    $condition: ModelReloadYardCapabilityConditionInput
  ) {
    updateReloadYardCapability(input: $input, condition: $condition) {
      id
      reloadYardId
      capabilityId
      owner
      groups
      active
      verified
      requiredValue
      capability {
        id
        active
        sortKey
        name
        description
        requiresValue
        requiredValueLabel
        quantity
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteReloadYardCapability = /* GraphQL */ `
  mutation DeleteReloadYardCapability(
    $input: DeleteReloadYardCapabilityInput!
    $condition: ModelReloadYardCapabilityConditionInput
  ) {
    deleteReloadYardCapability(input: $input, condition: $condition) {
      id
      reloadYardId
      capabilityId
      owner
      groups
      active
      verified
      requiredValue
      capability {
        id
        active
        sortKey
        name
        description
        requiresValue
        requiredValueLabel
        quantity
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createReloadYardCommodity = /* GraphQL */ `
  mutation CreateReloadYardCommodity(
    $input: CreateReloadYardCommodityInput!
    $condition: ModelReloadYardCommodityConditionInput
  ) {
    createReloadYardCommodity(input: $input, condition: $condition) {
      id
      reloadYardId
      commodityId
      owner
      groups
      active
      verified
      units
      showCounter
      sortKey
      commodity {
        id
        active
        sortKey
        name
        description
        defaultUnits
        locationLoadType
        validUom
        inventoryFields
        enableCounter
        prompt
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateReloadYardCommodity = /* GraphQL */ `
  mutation UpdateReloadYardCommodity(
    $input: UpdateReloadYardCommodityInput!
    $condition: ModelReloadYardCommodityConditionInput
  ) {
    updateReloadYardCommodity(input: $input, condition: $condition) {
      id
      reloadYardId
      commodityId
      owner
      groups
      active
      verified
      units
      showCounter
      sortKey
      commodity {
        id
        active
        sortKey
        name
        description
        defaultUnits
        locationLoadType
        validUom
        inventoryFields
        enableCounter
        prompt
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteReloadYardCommodity = /* GraphQL */ `
  mutation DeleteReloadYardCommodity(
    $input: DeleteReloadYardCommodityInput!
    $condition: ModelReloadYardCommodityConditionInput
  ) {
    deleteReloadYardCommodity(input: $input, condition: $condition) {
      id
      reloadYardId
      commodityId
      owner
      groups
      active
      verified
      units
      showCounter
      sortKey
      commodity {
        id
        active
        sortKey
        name
        description
        defaultUnits
        locationLoadType
        validUom
        inventoryFields
        enableCounter
        prompt
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createSavedAddress = /* GraphQL */ `
  mutation CreateSavedAddress(
    $input: CreateSavedAddressInput!
    $condition: ModelSavedAddressConditionInput
  ) {
    createSavedAddress(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      accountId
      name
      street
      city
      state
      zipCode
      country
      phone
      createdAt
      updatedAt
    }
  }
`;
export const updateSavedAddress = /* GraphQL */ `
  mutation UpdateSavedAddress(
    $input: UpdateSavedAddressInput!
    $condition: ModelSavedAddressConditionInput
  ) {
    updateSavedAddress(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      accountId
      name
      street
      city
      state
      zipCode
      country
      phone
      createdAt
      updatedAt
    }
  }
`;
export const deleteSavedAddress = /* GraphQL */ `
  mutation DeleteSavedAddress(
    $input: DeleteSavedAddressInput!
    $condition: ModelSavedAddressConditionInput
  ) {
    deleteSavedAddress(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      accountId
      name
      street
      city
      state
      zipCode
      country
      phone
      createdAt
      updatedAt
    }
  }
`;
export const createSeal = /* GraphQL */ `
  mutation CreateSeal(
    $input: CreateSealInput!
    $condition: ModelSealConditionInput
  ) {
    createSeal(input: $input, condition: $condition) {
      id
      active
      owner
      groups
      reloadYardId
      accountId
      accountName
      referenceId
      referenceName
      barcode
      isScanned
      createdAt
      createdBy
      validated
      reValidated
      brokenAt
      brokenBy
      description
      status
      updatedAt
    }
  }
`;
export const updateSeal = /* GraphQL */ `
  mutation UpdateSeal(
    $input: UpdateSealInput!
    $condition: ModelSealConditionInput
  ) {
    updateSeal(input: $input, condition: $condition) {
      id
      active
      owner
      groups
      reloadYardId
      accountId
      accountName
      referenceId
      referenceName
      barcode
      isScanned
      createdAt
      createdBy
      validated
      reValidated
      brokenAt
      brokenBy
      description
      status
      updatedAt
    }
  }
`;
export const deleteSeal = /* GraphQL */ `
  mutation DeleteSeal(
    $input: DeleteSealInput!
    $condition: ModelSealConditionInput
  ) {
    deleteSeal(input: $input, condition: $condition) {
      id
      active
      owner
      groups
      reloadYardId
      accountId
      accountName
      referenceId
      referenceName
      barcode
      isScanned
      createdAt
      createdBy
      validated
      reValidated
      brokenAt
      brokenBy
      description
      status
      updatedAt
    }
  }
`;
export const createService = /* GraphQL */ `
  mutation CreateService(
    $input: CreateServiceInput!
    $condition: ModelServiceConditionInput
  ) {
    createService(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      reloadYardId
      accountName
      accountId
      name
      description
      taxRate {
        taxCode
        name
        taxRate
      }
      unit
      pcs
      car
      tl
      mbf
      lf
      sf
      msf
      sqm
      gal
      l
      lbs
      tn
      cwt
      kg
      mt
      ft
      m
      createdAt
      updatedAt
    }
  }
`;
export const updateService = /* GraphQL */ `
  mutation UpdateService(
    $input: UpdateServiceInput!
    $condition: ModelServiceConditionInput
  ) {
    updateService(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      reloadYardId
      accountName
      accountId
      name
      description
      taxRate {
        taxCode
        name
        taxRate
      }
      unit
      pcs
      car
      tl
      mbf
      lf
      sf
      msf
      sqm
      gal
      l
      lbs
      tn
      cwt
      kg
      mt
      ft
      m
      createdAt
      updatedAt
    }
  }
`;
export const deleteService = /* GraphQL */ `
  mutation DeleteService(
    $input: DeleteServiceInput!
    $condition: ModelServiceConditionInput
  ) {
    deleteService(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      reloadYardId
      accountName
      accountId
      name
      description
      taxRate {
        taxCode
        name
        taxRate
      }
      unit
      pcs
      car
      tl
      mbf
      lf
      sf
      msf
      sqm
      gal
      l
      lbs
      tn
      cwt
      kg
      mt
      ft
      m
      createdAt
      updatedAt
    }
  }
`;
export const createSetupData = /* GraphQL */ `
  mutation CreateSetupData(
    $input: CreateSetupDataInput!
    $condition: ModelSetupDataConditionInput
  ) {
    createSetupData(input: $input, condition: $condition) {
      id
      owner
      groups
      status
      cognitoId
      firstName
      lastName
      businessName
      setupData
      submitDate
      approvalDate
      approvedBy
      createdAt
      updatedAt
    }
  }
`;
export const updateSetupData = /* GraphQL */ `
  mutation UpdateSetupData(
    $input: UpdateSetupDataInput!
    $condition: ModelSetupDataConditionInput
  ) {
    updateSetupData(input: $input, condition: $condition) {
      id
      owner
      groups
      status
      cognitoId
      firstName
      lastName
      businessName
      setupData
      submitDate
      approvalDate
      approvedBy
      createdAt
      updatedAt
    }
  }
`;
export const deleteSetupData = /* GraphQL */ `
  mutation DeleteSetupData(
    $input: DeleteSetupDataInput!
    $condition: ModelSetupDataConditionInput
  ) {
    deleteSetupData(input: $input, condition: $condition) {
      id
      owner
      groups
      status
      cognitoId
      firstName
      lastName
      businessName
      setupData
      submitDate
      approvalDate
      approvedBy
      createdAt
      updatedAt
    }
  }
`;
export const createShipmentLineItem = /* GraphQL */ `
  mutation CreateShipmentLineItem(
    $input: CreateShipmentLineItemInput!
    $condition: ModelShipmentLineItemConditionInput
  ) {
    createShipmentLineItem(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      sortKey
      lotNumber
      poNumber
      totalQuantityToPick
      totalQuantityReturned
      units
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      pickupPhoto {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      outboundShipmentId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      accountId
      reloadYardId
      inventoryId
      inventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      inventoryItems {
        items {
          id
          owner
          groups
          reloadYardId
          outboundShipmentId
          shipmentLineItemId
          inventoryId
          inventoryItemId
          quantityToPick
          quantityReturned
          scannedOut
          loadedBy
          units
          status
          hasException
          barcodeException
          barcodeExceptionNote
          otherException
          otherExceptionNote
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateShipmentLineItem = /* GraphQL */ `
  mutation UpdateShipmentLineItem(
    $input: UpdateShipmentLineItemInput!
    $condition: ModelShipmentLineItemConditionInput
  ) {
    updateShipmentLineItem(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      sortKey
      lotNumber
      poNumber
      totalQuantityToPick
      totalQuantityReturned
      units
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      pickupPhoto {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      outboundShipmentId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      accountId
      reloadYardId
      inventoryId
      inventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      inventoryItems {
        items {
          id
          owner
          groups
          reloadYardId
          outboundShipmentId
          shipmentLineItemId
          inventoryId
          inventoryItemId
          quantityToPick
          quantityReturned
          scannedOut
          loadedBy
          units
          status
          hasException
          barcodeException
          barcodeExceptionNote
          otherException
          otherExceptionNote
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteShipmentLineItem = /* GraphQL */ `
  mutation DeleteShipmentLineItem(
    $input: DeleteShipmentLineItemInput!
    $condition: ModelShipmentLineItemConditionInput
  ) {
    deleteShipmentLineItem(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      sortKey
      lotNumber
      poNumber
      totalQuantityToPick
      totalQuantityReturned
      units
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      pickupPhoto {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      outboundShipmentId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      accountId
      reloadYardId
      inventoryId
      inventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      inventoryItems {
        items {
          id
          owner
          groups
          reloadYardId
          outboundShipmentId
          shipmentLineItemId
          inventoryId
          inventoryItemId
          quantityToPick
          quantityReturned
          scannedOut
          loadedBy
          units
          status
          hasException
          barcodeException
          barcodeExceptionNote
          otherException
          otherExceptionNote
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createShipmentLineItemInventoryItem = /* GraphQL */ `
  mutation CreateShipmentLineItemInventoryItem(
    $input: CreateShipmentLineItemInventoryItemInput!
    $condition: ModelShipmentLineItemInventoryItemConditionInput
  ) {
    createShipmentLineItemInventoryItem(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      outboundShipmentId
      shipmentLineItemId
      inventoryId
      inventoryItemId
      inventoryItem {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      quantityToPick
      quantityReturned
      scannedOut
      loadedBy
      units
      status
      hasException
      barcodeException
      barcodeExceptionNote
      otherException
      otherExceptionNote
      createdAt
      updatedAt
    }
  }
`;
export const updateShipmentLineItemInventoryItem = /* GraphQL */ `
  mutation UpdateShipmentLineItemInventoryItem(
    $input: UpdateShipmentLineItemInventoryItemInput!
    $condition: ModelShipmentLineItemInventoryItemConditionInput
  ) {
    updateShipmentLineItemInventoryItem(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      outboundShipmentId
      shipmentLineItemId
      inventoryId
      inventoryItemId
      inventoryItem {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      quantityToPick
      quantityReturned
      scannedOut
      loadedBy
      units
      status
      hasException
      barcodeException
      barcodeExceptionNote
      otherException
      otherExceptionNote
      createdAt
      updatedAt
    }
  }
`;
export const deleteShipmentLineItemInventoryItem = /* GraphQL */ `
  mutation DeleteShipmentLineItemInventoryItem(
    $input: DeleteShipmentLineItemInventoryItemInput!
    $condition: ModelShipmentLineItemInventoryItemConditionInput
  ) {
    deleteShipmentLineItemInventoryItem(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      outboundShipmentId
      shipmentLineItemId
      inventoryId
      inventoryItemId
      inventoryItem {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      quantityToPick
      quantityReturned
      scannedOut
      loadedBy
      units
      status
      hasException
      barcodeException
      barcodeExceptionNote
      otherException
      otherExceptionNote
      createdAt
      updatedAt
    }
  }
`;
export const createSupportRequest = /* GraphQL */ `
  mutation CreateSupportRequest(
    $input: CreateSupportRequestInput!
    $condition: ModelSupportRequestConditionInput
  ) {
    createSupportRequest(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      reloadYardId
      subject
      description
      requirements
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      submittedAt
      approvedPriceCents
      maxRevisions
      approvedBy
      approvedAt
      quoteExpiresAt
      estimatedDays
      stripeCheckoutSessionId
      stripePaymentIntentId
      stripePaymentStatus
      paidAt
      startedAt
      deliveredAt
      revisionCount
      deliveryNotes
      deliveryAttachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateSupportRequest = /* GraphQL */ `
  mutation UpdateSupportRequest(
    $input: UpdateSupportRequestInput!
    $condition: ModelSupportRequestConditionInput
  ) {
    updateSupportRequest(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      reloadYardId
      subject
      description
      requirements
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      submittedAt
      approvedPriceCents
      maxRevisions
      approvedBy
      approvedAt
      quoteExpiresAt
      estimatedDays
      stripeCheckoutSessionId
      stripePaymentIntentId
      stripePaymentStatus
      paidAt
      startedAt
      deliveredAt
      revisionCount
      deliveryNotes
      deliveryAttachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteSupportRequest = /* GraphQL */ `
  mutation DeleteSupportRequest(
    $input: DeleteSupportRequestInput!
    $condition: ModelSupportRequestConditionInput
  ) {
    deleteSupportRequest(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      reloadYardId
      subject
      description
      requirements
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      submittedAt
      approvedPriceCents
      maxRevisions
      approvedBy
      approvedAt
      quoteExpiresAt
      estimatedDays
      stripeCheckoutSessionId
      stripePaymentIntentId
      stripePaymentStatus
      paidAt
      startedAt
      deliveredAt
      revisionCount
      deliveryNotes
      deliveryAttachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createTag = /* GraphQL */ `
  mutation CreateTag(
    $input: CreateTagInput!
    $condition: ModelTagConditionInput
  ) {
    createTag(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      name
      description
      createdAt
      updatedAt
    }
  }
`;
export const updateTag = /* GraphQL */ `
  mutation UpdateTag(
    $input: UpdateTagInput!
    $condition: ModelTagConditionInput
  ) {
    updateTag(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      name
      description
      createdAt
      updatedAt
    }
  }
`;
export const deleteTag = /* GraphQL */ `
  mutation DeleteTag(
    $input: DeleteTagInput!
    $condition: ModelTagConditionInput
  ) {
    deleteTag(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      name
      description
      createdAt
      updatedAt
    }
  }
`;
export const createTask = /* GraphQL */ `
  mutation CreateTask(
    $input: CreateTaskInput!
    $condition: ModelTaskConditionInput
  ) {
    createTask(input: $input, condition: $condition) {
      id
      owner
      groups
      status
      reloadYardId
      createdAt
      updatedAt
      name
      description
      assignedTo
      assignedToName
      allowReassign
      link
      priority
      reference
      category
      dueDate
      lateDate
      completedBy
      completedDate
      resolvedDate
      resolvedBy
      note
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
    }
  }
`;
export const updateTask = /* GraphQL */ `
  mutation UpdateTask(
    $input: UpdateTaskInput!
    $condition: ModelTaskConditionInput
  ) {
    updateTask(input: $input, condition: $condition) {
      id
      owner
      groups
      status
      reloadYardId
      createdAt
      updatedAt
      name
      description
      assignedTo
      assignedToName
      allowReassign
      link
      priority
      reference
      category
      dueDate
      lateDate
      completedBy
      completedDate
      resolvedDate
      resolvedBy
      note
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
    }
  }
`;
export const deleteTask = /* GraphQL */ `
  mutation DeleteTask(
    $input: DeleteTaskInput!
    $condition: ModelTaskConditionInput
  ) {
    deleteTask(input: $input, condition: $condition) {
      id
      owner
      groups
      status
      reloadYardId
      createdAt
      updatedAt
      name
      description
      assignedTo
      assignedToName
      allowReassign
      link
      priority
      reference
      category
      dueDate
      lateDate
      completedBy
      completedDate
      resolvedDate
      resolvedBy
      note
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
    }
  }
`;
export const createTimeslot = /* GraphQL */ `
  mutation CreateTimeslot(
    $input: CreateTimeslotInput!
    $condition: ModelTimeslotConditionInput
  ) {
    createTimeslot(input: $input, condition: $condition) {
      id
      owner
      groups
      status
      reloadYardId
      year
      month
      week
      day
      time
      startTime
      endTime
      inboundId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outboundId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      accountName
      accountId
      eventTypeId
      eventType {
        id
        owner
        groups
        active
        reloadYardId
        areaId
        name
        description
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        duration
        bufferTime
        resourceName
        numberOfResources
        assetTypeId
        assetType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          maxConcurrentBookings
          createdAt
          updatedAt
        }
        workflow
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      carrierId
      carrier {
        id
        owner
        active
        groups
        businessName
        dbaName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        companyId
        reloadYardId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      carrierUserId
      carrierUser {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateTimeslot = /* GraphQL */ `
  mutation UpdateTimeslot(
    $input: UpdateTimeslotInput!
    $condition: ModelTimeslotConditionInput
  ) {
    updateTimeslot(input: $input, condition: $condition) {
      id
      owner
      groups
      status
      reloadYardId
      year
      month
      week
      day
      time
      startTime
      endTime
      inboundId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outboundId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      accountName
      accountId
      eventTypeId
      eventType {
        id
        owner
        groups
        active
        reloadYardId
        areaId
        name
        description
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        duration
        bufferTime
        resourceName
        numberOfResources
        assetTypeId
        assetType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          maxConcurrentBookings
          createdAt
          updatedAt
        }
        workflow
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      carrierId
      carrier {
        id
        owner
        active
        groups
        businessName
        dbaName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        companyId
        reloadYardId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      carrierUserId
      carrierUser {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteTimeslot = /* GraphQL */ `
  mutation DeleteTimeslot(
    $input: DeleteTimeslotInput!
    $condition: ModelTimeslotConditionInput
  ) {
    deleteTimeslot(input: $input, condition: $condition) {
      id
      owner
      groups
      status
      reloadYardId
      year
      month
      week
      day
      time
      startTime
      endTime
      inboundId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outboundId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      accountName
      accountId
      eventTypeId
      eventType {
        id
        owner
        groups
        active
        reloadYardId
        areaId
        name
        description
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        duration
        bufferTime
        resourceName
        numberOfResources
        assetTypeId
        assetType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          maxConcurrentBookings
          createdAt
          updatedAt
        }
        workflow
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      carrierId
      carrier {
        id
        owner
        active
        groups
        businessName
        dbaName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        companyId
        reloadYardId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      carrierUserId
      carrierUser {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createTrackCar = /* GraphQL */ `
  mutation CreateTrackCar(
    $input: CreateTrackCarInput!
    $condition: ModelTrackCarConditionInput
  ) {
    createTrackCar(input: $input, condition: $condition) {
      id
      active
      owner
      areaId
      zoneId
      aisleId
      trackId
      eodTrackId
      location {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      locationFullName
      reloadYardId
      accountId
      shipmentId
      parentType
      inbound {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outbound {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      railCarNumber
      sortKey
      eodSortKey
      movementLogs {
        trackCarId
        sortKey
        movedAt
        movedBy
      }
      updatedAt
      updatedBy
      createdAt
    }
  }
`;
export const updateTrackCar = /* GraphQL */ `
  mutation UpdateTrackCar(
    $input: UpdateTrackCarInput!
    $condition: ModelTrackCarConditionInput
  ) {
    updateTrackCar(input: $input, condition: $condition) {
      id
      active
      owner
      areaId
      zoneId
      aisleId
      trackId
      eodTrackId
      location {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      locationFullName
      reloadYardId
      accountId
      shipmentId
      parentType
      inbound {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outbound {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      railCarNumber
      sortKey
      eodSortKey
      movementLogs {
        trackCarId
        sortKey
        movedAt
        movedBy
      }
      updatedAt
      updatedBy
      createdAt
    }
  }
`;
export const deleteTrackCar = /* GraphQL */ `
  mutation DeleteTrackCar(
    $input: DeleteTrackCarInput!
    $condition: ModelTrackCarConditionInput
  ) {
    deleteTrackCar(input: $input, condition: $condition) {
      id
      active
      owner
      areaId
      zoneId
      aisleId
      trackId
      eodTrackId
      location {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      locationFullName
      reloadYardId
      accountId
      shipmentId
      parentType
      inbound {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outbound {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      railCarNumber
      sortKey
      eodSortKey
      movementLogs {
        trackCarId
        sortKey
        movedAt
        movedBy
      }
      updatedAt
      updatedBy
      createdAt
    }
  }
`;
export const createTruckEquipmentType = /* GraphQL */ `
  mutation CreateTruckEquipmentType(
    $input: CreateTruckEquipmentTypeInput!
    $condition: ModelTruckEquipmentTypeConditionInput
  ) {
    createTruckEquipmentType(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      name
      dotSpecCode
      dotClassCode
      length
      reloadYardId
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const updateTruckEquipmentType = /* GraphQL */ `
  mutation UpdateTruckEquipmentType(
    $input: UpdateTruckEquipmentTypeInput!
    $condition: ModelTruckEquipmentTypeConditionInput
  ) {
    updateTruckEquipmentType(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      name
      dotSpecCode
      dotClassCode
      length
      reloadYardId
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const deleteTruckEquipmentType = /* GraphQL */ `
  mutation DeleteTruckEquipmentType(
    $input: DeleteTruckEquipmentTypeInput!
    $condition: ModelTruckEquipmentTypeConditionInput
  ) {
    deleteTruckEquipmentType(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      name
      dotSpecCode
      dotClassCode
      length
      reloadYardId
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      cognitoId
      type
      firstName
      lastName
      fullName
      phone
      email
      unsubscribed
      address {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      reloadYardId
      acl
      createdAt
      updatedAt
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      cognitoId
      type
      firstName
      lastName
      fullName
      phone
      email
      unsubscribed
      address {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      reloadYardId
      acl
      createdAt
      updatedAt
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      cognitoId
      type
      firstName
      lastName
      fullName
      phone
      email
      unsubscribed
      address {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      reloadYardId
      acl
      createdAt
      updatedAt
    }
  }
`;
export const createWorkChargeRule = /* GraphQL */ `
  mutation CreateWorkChargeRule(
    $input: CreateWorkChargeRuleInput!
    $condition: ModelWorkChargeRuleConditionInput
  ) {
    createWorkChargeRule(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      parentId
      parentType
      chargeRuleId
      chargeRule {
        id
        owner
        active
        groups
        accountId
        reloadYardId
        event
        serviceId
        service {
          id
          owner
          groups
          active
          status
          reloadYardId
          accountName
          accountId
          name
          description
          unit
          pcs
          car
          tl
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          createdAt
          updatedAt
        }
        billingUOM
        reloadYardCommodityId
        carrierType
        carrierEquipmentTypeId
        areaId
        zoneId
        graduatedRates {
          days
          rate
        }
        minCharge
        maxCharge
        execution
        frequency
        feeAccrual
        freeDaysPolicy
        freeDays
        freeCars
        createdAt
        updatedAt
      }
      quantity
      sortKey
      invoiceServiceId
      createdAt
      updatedAt
    }
  }
`;
export const updateWorkChargeRule = /* GraphQL */ `
  mutation UpdateWorkChargeRule(
    $input: UpdateWorkChargeRuleInput!
    $condition: ModelWorkChargeRuleConditionInput
  ) {
    updateWorkChargeRule(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      parentId
      parentType
      chargeRuleId
      chargeRule {
        id
        owner
        active
        groups
        accountId
        reloadYardId
        event
        serviceId
        service {
          id
          owner
          groups
          active
          status
          reloadYardId
          accountName
          accountId
          name
          description
          unit
          pcs
          car
          tl
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          createdAt
          updatedAt
        }
        billingUOM
        reloadYardCommodityId
        carrierType
        carrierEquipmentTypeId
        areaId
        zoneId
        graduatedRates {
          days
          rate
        }
        minCharge
        maxCharge
        execution
        frequency
        feeAccrual
        freeDaysPolicy
        freeDays
        freeCars
        createdAt
        updatedAt
      }
      quantity
      sortKey
      invoiceServiceId
      createdAt
      updatedAt
    }
  }
`;
export const deleteWorkChargeRule = /* GraphQL */ `
  mutation DeleteWorkChargeRule(
    $input: DeleteWorkChargeRuleInput!
    $condition: ModelWorkChargeRuleConditionInput
  ) {
    deleteWorkChargeRule(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      parentId
      parentType
      chargeRuleId
      chargeRule {
        id
        owner
        active
        groups
        accountId
        reloadYardId
        event
        serviceId
        service {
          id
          owner
          groups
          active
          status
          reloadYardId
          accountName
          accountId
          name
          description
          unit
          pcs
          car
          tl
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          createdAt
          updatedAt
        }
        billingUOM
        reloadYardCommodityId
        carrierType
        carrierEquipmentTypeId
        areaId
        zoneId
        graduatedRates {
          days
          rate
        }
        minCharge
        maxCharge
        execution
        frequency
        feeAccrual
        freeDaysPolicy
        freeDays
        freeCars
        createdAt
        updatedAt
      }
      quantity
      sortKey
      invoiceServiceId
      createdAt
      updatedAt
    }
  }
`;
export const createWorkOrder = /* GraphQL */ `
  mutation CreateWorkOrder(
    $input: CreateWorkOrderInput!
    $condition: ModelWorkOrderConditionInput
  ) {
    createWorkOrder(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      state
      workType
      poNumber
      normalizedPoNumber
      totalUOM
      skipInvoice
      createDateTime
      startDateTime
      endDateTime
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      assignedTo
      workflowType
      processedBy
      verificationRequired
      hasException
      brokenSeal
      brokenSealNote
      otherException
      otherExceptionNote
      instructions
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      accountName
      accountId
      billToAccountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      billToAccount {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      inputInventoryId
      inputInventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      workOrderItems {
        items {
          id
          owner
          groups
          active
          status
          workOrderId
          sortKey
          poNumber
          quantityToProcess
          units
          accountId
          reloadYardId
          inputInventoryId
          inputInventoryItemId
          createdAt
          updatedAt
        }
        nextToken
      }
      outputInventories {
        items {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        nextToken
      }
      manualCharges {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          chargeRuleId
          quantity
          sortKey
          invoiceServiceId
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      customFields
      selectedCustomFields {
        id
        name
        type
        display
        required
      }
      stepName
      createdAt
      updatedAt
    }
  }
`;
export const updateWorkOrder = /* GraphQL */ `
  mutation UpdateWorkOrder(
    $input: UpdateWorkOrderInput!
    $condition: ModelWorkOrderConditionInput
  ) {
    updateWorkOrder(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      state
      workType
      poNumber
      normalizedPoNumber
      totalUOM
      skipInvoice
      createDateTime
      startDateTime
      endDateTime
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      assignedTo
      workflowType
      processedBy
      verificationRequired
      hasException
      brokenSeal
      brokenSealNote
      otherException
      otherExceptionNote
      instructions
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      accountName
      accountId
      billToAccountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      billToAccount {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      inputInventoryId
      inputInventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      workOrderItems {
        items {
          id
          owner
          groups
          active
          status
          workOrderId
          sortKey
          poNumber
          quantityToProcess
          units
          accountId
          reloadYardId
          inputInventoryId
          inputInventoryItemId
          createdAt
          updatedAt
        }
        nextToken
      }
      outputInventories {
        items {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        nextToken
      }
      manualCharges {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          chargeRuleId
          quantity
          sortKey
          invoiceServiceId
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      customFields
      selectedCustomFields {
        id
        name
        type
        display
        required
      }
      stepName
      createdAt
      updatedAt
    }
  }
`;
export const deleteWorkOrder = /* GraphQL */ `
  mutation DeleteWorkOrder(
    $input: DeleteWorkOrderInput!
    $condition: ModelWorkOrderConditionInput
  ) {
    deleteWorkOrder(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      state
      workType
      poNumber
      normalizedPoNumber
      totalUOM
      skipInvoice
      createDateTime
      startDateTime
      endDateTime
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      assignedTo
      workflowType
      processedBy
      verificationRequired
      hasException
      brokenSeal
      brokenSealNote
      otherException
      otherExceptionNote
      instructions
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      accountName
      accountId
      billToAccountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      billToAccount {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      inputInventoryId
      inputInventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      workOrderItems {
        items {
          id
          owner
          groups
          active
          status
          workOrderId
          sortKey
          poNumber
          quantityToProcess
          units
          accountId
          reloadYardId
          inputInventoryId
          inputInventoryItemId
          createdAt
          updatedAt
        }
        nextToken
      }
      outputInventories {
        items {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        nextToken
      }
      manualCharges {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          chargeRuleId
          quantity
          sortKey
          invoiceServiceId
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      customFields
      selectedCustomFields {
        id
        name
        type
        display
        required
      }
      stepName
      createdAt
      updatedAt
    }
  }
`;
export const createWorkOrderItem = /* GraphQL */ `
  mutation CreateWorkOrderItem(
    $input: CreateWorkOrderItemInput!
    $condition: ModelWorkOrderItemConditionInput
  ) {
    createWorkOrderItem(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      workOrderId
      sortKey
      poNumber
      quantityToProcess
      units
      history {
        type
        date
        by
        text
        public
      }
      accountId
      reloadYardId
      inputInventoryId
      inputInventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      inputInventoryItemId
      inputInventoryItem {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateWorkOrderItem = /* GraphQL */ `
  mutation UpdateWorkOrderItem(
    $input: UpdateWorkOrderItemInput!
    $condition: ModelWorkOrderItemConditionInput
  ) {
    updateWorkOrderItem(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      workOrderId
      sortKey
      poNumber
      quantityToProcess
      units
      history {
        type
        date
        by
        text
        public
      }
      accountId
      reloadYardId
      inputInventoryId
      inputInventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      inputInventoryItemId
      inputInventoryItem {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteWorkOrderItem = /* GraphQL */ `
  mutation DeleteWorkOrderItem(
    $input: DeleteWorkOrderItemInput!
    $condition: ModelWorkOrderItemConditionInput
  ) {
    deleteWorkOrderItem(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      workOrderId
      sortKey
      poNumber
      quantityToProcess
      units
      history {
        type
        date
        by
        text
        public
      }
      accountId
      reloadYardId
      inputInventoryId
      inputInventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      inputInventoryItemId
      inputInventoryItem {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createZapierHook = /* GraphQL */ `
  mutation CreateZapierHook(
    $input: CreateZapierHookInput!
    $condition: ModelZapierHookConditionInput
  ) {
    createZapierHook(input: $input, condition: $condition) {
      id
      groups
      active
      reloadYardId
      event
      zapId
      url
      link
      options
      createdAt
      updatedAt
    }
  }
`;
export const updateZapierHook = /* GraphQL */ `
  mutation UpdateZapierHook(
    $input: UpdateZapierHookInput!
    $condition: ModelZapierHookConditionInput
  ) {
    updateZapierHook(input: $input, condition: $condition) {
      id
      groups
      active
      reloadYardId
      event
      zapId
      url
      link
      options
      createdAt
      updatedAt
    }
  }
`;
export const deleteZapierHook = /* GraphQL */ `
  mutation DeleteZapierHook(
    $input: DeleteZapierHookInput!
    $condition: ModelZapierHookConditionInput
  ) {
    deleteZapierHook(input: $input, condition: $condition) {
      id
      groups
      active
      reloadYardId
      event
      zapId
      url
      link
      options
      createdAt
      updatedAt
    }
  }
`;
export const createZapierAction = /* GraphQL */ `
  mutation CreateZapierAction(
    $input: CreateZapierActionInput!
    $condition: ModelZapierActionConditionInput
  ) {
    createZapierAction(input: $input, condition: $condition) {
      id
      groups
      active
      reloadYardId
      event
      name
      description
      counter
      createdAt
      updatedAt
    }
  }
`;
export const updateZapierAction = /* GraphQL */ `
  mutation UpdateZapierAction(
    $input: UpdateZapierActionInput!
    $condition: ModelZapierActionConditionInput
  ) {
    updateZapierAction(input: $input, condition: $condition) {
      id
      groups
      active
      reloadYardId
      event
      name
      description
      counter
      createdAt
      updatedAt
    }
  }
`;
export const deleteZapierAction = /* GraphQL */ `
  mutation DeleteZapierAction(
    $input: DeleteZapierActionInput!
    $condition: ModelZapierActionConditionInput
  ) {
    deleteZapierAction(input: $input, condition: $condition) {
      id
      groups
      active
      reloadYardId
      event
      name
      description
      counter
      createdAt
      updatedAt
    }
  }
`;
export const createZone = /* GraphQL */ `
  mutation CreateZone(
    $input: CreateZoneInput!
    $condition: ModelZoneConditionInput
  ) {
    createZone(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      reloadYardId
      name
      prefix
      accountId
      leasedArea
      leasedAreaUOM
      areaId
      aisles {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        nextToken
      }
      color
      zoneType
      reloadYardCommodityId
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const updateZone = /* GraphQL */ `
  mutation UpdateZone(
    $input: UpdateZoneInput!
    $condition: ModelZoneConditionInput
  ) {
    updateZone(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      reloadYardId
      name
      prefix
      accountId
      leasedArea
      leasedAreaUOM
      areaId
      aisles {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        nextToken
      }
      color
      zoneType
      reloadYardCommodityId
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const deleteZone = /* GraphQL */ `
  mutation DeleteZone(
    $input: DeleteZoneInput!
    $condition: ModelZoneConditionInput
  ) {
    deleteZone(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      reloadYardId
      name
      prefix
      accountId
      leasedArea
      leasedAreaUOM
      areaId
      aisles {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        nextToken
      }
      color
      zoneType
      reloadYardCommodityId
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const createCarrierUserIdentity = /* GraphQL */ `
  mutation CreateCarrierUserIdentity(
    $input: CreateCarrierUserIdentityInput!
    $condition: ModelCarrierUserIdentityConditionInput
  ) {
    createCarrierUserIdentity(input: $input, condition: $condition) {
      id
      status
      rekognitionFaceId
      rekognitionCollection
      faceImageKey
      idDocType
      idDocLast4
      idDocExpiry
      idDocState
      idDocClass
      idDocLastName
      idDocFirstInitial
      idDocImageKey
      idDocRetention
      idDocCapturedAt
      idDocSource
      idDocReplacedAt
      idDocDeletedAt
      consentAt
      consentVersion
      consentLocale
      consentTextHash
      faceConsentDeclinedAt
      consentWithdrawnAt
      consentWithdrawnBy
      enrolledVia
      enrolledBy
      enrolledAtYardId
      createdAt
      updatedAt
    }
  }
`;
export const updateCarrierUserIdentity = /* GraphQL */ `
  mutation UpdateCarrierUserIdentity(
    $input: UpdateCarrierUserIdentityInput!
    $condition: ModelCarrierUserIdentityConditionInput
  ) {
    updateCarrierUserIdentity(input: $input, condition: $condition) {
      id
      status
      rekognitionFaceId
      rekognitionCollection
      faceImageKey
      idDocType
      idDocLast4
      idDocExpiry
      idDocState
      idDocClass
      idDocLastName
      idDocFirstInitial
      idDocImageKey
      idDocRetention
      idDocCapturedAt
      idDocSource
      idDocReplacedAt
      idDocDeletedAt
      consentAt
      consentVersion
      consentLocale
      consentTextHash
      faceConsentDeclinedAt
      consentWithdrawnAt
      consentWithdrawnBy
      enrolledVia
      enrolledBy
      enrolledAtYardId
      createdAt
      updatedAt
    }
  }
`;
export const deleteCarrierUserIdentity = /* GraphQL */ `
  mutation DeleteCarrierUserIdentity(
    $input: DeleteCarrierUserIdentityInput!
    $condition: ModelCarrierUserIdentityConditionInput
  ) {
    deleteCarrierUserIdentity(input: $input, condition: $condition) {
      id
      status
      rekognitionFaceId
      rekognitionCollection
      faceImageKey
      idDocType
      idDocLast4
      idDocExpiry
      idDocState
      idDocClass
      idDocLastName
      idDocFirstInitial
      idDocImageKey
      idDocRetention
      idDocCapturedAt
      idDocSource
      idDocReplacedAt
      idDocDeletedAt
      consentAt
      consentVersion
      consentLocale
      consentTextHash
      faceConsentDeclinedAt
      consentWithdrawnAt
      consentWithdrawnBy
      enrolledVia
      enrolledBy
      enrolledAtYardId
      createdAt
      updatedAt
    }
  }
`;
export const createDriverSession = /* GraphQL */ `
  mutation CreateDriverSession(
    $input: CreateDriverSessionInput!
    $condition: ModelDriverSessionConditionInput
  ) {
    createDriverSession(input: $input, condition: $condition) {
      id
      reloadYardId
      carrierUserId
      gateCheckInId
      ip
      userAgent
      windowStart
      searchCount
      identifyCount
      enrollCount
      captureCount
      revoked
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const updateDriverSession = /* GraphQL */ `
  mutation UpdateDriverSession(
    $input: UpdateDriverSessionInput!
    $condition: ModelDriverSessionConditionInput
  ) {
    updateDriverSession(input: $input, condition: $condition) {
      id
      reloadYardId
      carrierUserId
      gateCheckInId
      ip
      userAgent
      windowStart
      searchCount
      identifyCount
      enrollCount
      captureCount
      revoked
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const deleteDriverSession = /* GraphQL */ `
  mutation DeleteDriverSession(
    $input: DeleteDriverSessionInput!
    $condition: ModelDriverSessionConditionInput
  ) {
    deleteDriverSession(input: $input, condition: $condition) {
      id
      reloadYardId
      carrierUserId
      gateCheckInId
      ip
      userAgent
      windowStart
      searchCount
      identifyCount
      enrollCount
      captureCount
      revoked
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const createGateCheckIn = /* GraphQL */ `
  mutation CreateGateCheckIn(
    $input: CreateGateCheckInInput!
    $condition: ModelGateCheckInConditionInput
  ) {
    createGateCheckIn(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      driverSessionId
      carrierUserId
      carrierId
      carrierName
      driverName
      shipmentKey
      inboundId
      outboundId
      timeslotId
      scheduledDateTime
      referenceEntered
      driverNameEntered
      truckPlate
      trailerNumber
      latitude
      longitude
      locationAccuracy
      status
      dockAssignment
      arrivedAt
      calledAt
      completedAt
      updatedBy
      outboundIds
      createdAt
      updatedAt
    }
  }
`;
export const updateGateCheckIn = /* GraphQL */ `
  mutation UpdateGateCheckIn(
    $input: UpdateGateCheckInInput!
    $condition: ModelGateCheckInConditionInput
  ) {
    updateGateCheckIn(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      driverSessionId
      carrierUserId
      carrierId
      carrierName
      driverName
      shipmentKey
      inboundId
      outboundId
      timeslotId
      scheduledDateTime
      referenceEntered
      driverNameEntered
      truckPlate
      trailerNumber
      latitude
      longitude
      locationAccuracy
      status
      dockAssignment
      arrivedAt
      calledAt
      completedAt
      updatedBy
      outboundIds
      createdAt
      updatedAt
    }
  }
`;
export const deleteGateCheckIn = /* GraphQL */ `
  mutation DeleteGateCheckIn(
    $input: DeleteGateCheckInInput!
    $condition: ModelGateCheckInConditionInput
  ) {
    deleteGateCheckIn(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      driverSessionId
      carrierUserId
      carrierId
      carrierName
      driverName
      shipmentKey
      inboundId
      outboundId
      timeslotId
      scheduledDateTime
      referenceEntered
      driverNameEntered
      truckPlate
      trailerNumber
      latitude
      longitude
      locationAccuracy
      status
      dockAssignment
      arrivedAt
      calledAt
      completedAt
      updatedBy
      outboundIds
      createdAt
      updatedAt
    }
  }
`;
